var module;
// LICENSE_CODE ZON ISC
'use strict'; /*jslint node:true, browser:true*/
(function () {
  var is_node = typeof module == 'object' && module.exports && module.children;
  if (!is_node) ;else ;
  define([], function () {
    var E = {};
    E.continents = ['europe', 'north-america', 'latin-america', 'asia', 'africa', 'oceania'];
    E.list = {
      AF: 'Afghanistan',
      AL: 'Albania',
      DZ: 'Algeria',
      AX: 'Aland Islands',
      AS: 'American Samoa',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarctica',
      AG: 'Antigua And Barbuda',
      AR: 'Argentina',
      AM: 'Armenia',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbaijan',
      BS: 'Bahamas',
      BH: 'Bahrain',
      JE: 'Bailiwick of Jersey',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Belarus',
      BE: 'Belgium',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BO: 'Bolivia',
      BQ: 'Bonaire (Caribbean Netherlands)',
      BA: 'Bosnia And Herzegovina',
      BW: 'Botswana',
      BR: 'Brazil',
      BN: 'Brunei',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambodia',
      CM: 'Cameroon',
      CA: 'Canada',
      CV: 'Cape Verde',
      KY: 'Cayman Islands',
      CF: 'Central African Republic',
      TD: 'Chad',
      CL: 'Chile',
      CN: 'China',
      CX: 'Christmas Island',
      CC: 'Cocos (Keeling) Islands',
      CO: 'Colombia',
      KM: 'Comoros',
      CG: 'Congo',
      CK: 'Cook Islands',
      CR: 'Costa Rica',
      CI: 'Cote D\'Ivoire (Ivory Coast)',
      HR: 'Croatia (Hrvatska)',
      CU: 'Cuba',
      CW: 'Curacao',
      CY: 'Cyprus',
      CZ: 'Czech Republic',
      CD: 'Democratic Republic Of Congo (Zaire)',
      DK: 'Denmark',
      DJ: 'Djibouti',
      DM: 'Dominica',
      DO: 'Dominican Republic',
      EC: 'Ecuador',
      EG: 'Egypt',
      SV: 'El Salvador',
      GQ: 'Equatorial Guinea',
      ER: 'Eritrea',
      EU: 'European Union',
      EE: 'Estonia',
      ET: 'Ethiopia',
      FK: 'Falkland Islands (Malvinas)',
      FO: 'Faroe Islands',
      FJ: 'Fiji',
      FI: 'Finland',
      FR: 'France',
      GF: 'French Guiana',
      PF: 'French Polynesia',
      TF: 'French Southern Territories',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      DE: 'Germany',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GB: 'Great Britain',
      GR: 'Greece',
      GL: 'Greenland',
      GD: 'Grenada',
      GU: 'Guam',
      GP: 'Guadeloupe',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Hungary',
      IS: 'Iceland',
      IN: 'India',
      ID: 'Indonesia',
      IR: 'Iran',
      IQ: 'Iraq',
      IE: 'Ireland',
      IM: 'Isle of Man',
      IL: 'Israel',
      IT: 'Italy',
      JM: 'Jamaica',
      JP: 'Japan',
      JO: 'Jordan',
      KZ: 'Kazakhstan',
      KE: 'Kenya',
      KI: 'Kiribati',
      XK: 'Kosovo',
      KW: 'Kuwait',
      KG: 'Kyrgyzstan',
      LA: 'Laos',
      LV: 'Latvia',
      LB: 'Lebanon',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libya',
      LI: 'Liechtenstein',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      MO: 'Macau',
      MK: 'Macedonia',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malaysia',
      MV: 'Maldives',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Marshall Islands',
      MQ: 'Martinique',
      MR: 'Mauritania',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Mexico',
      FM: 'Micronesia',
      MD: 'Moldova',
      MC: 'Monaco',
      MN: 'Mongolia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Morocco',
      MZ: 'Mozambique',
      MM: 'Myanmar (Burma)',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Netherlands',
      AN: 'Netherlands Antilles',
      NC: 'New Caledonia',
      NZ: 'New Zealand',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Norfolk Island',
      KP: 'North Korea',
      MP: 'Northern Mariana Islands',
      NO: 'Norway',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Palestine',
      PA: 'Panama',
      PG: 'Papua New Guinea',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Philippines',
      PN: 'Pitcairn',
      PL: 'Poland',
      PT: 'Portugal',
      PR: 'Puerto Rico',
      QA: 'Qatar',
      RE: 'Reunion',
      RO: 'Romania',
      RU: 'Russia',
      RW: 'Rwanda',
      BL: 'Saint Barthelemy',
      SH: 'Saint Helena',
      KN: 'Saint Kitts And Nevis',
      LC: 'Saint Lucia',
      MF: 'Saint Martin',
      VC: 'Saint Vincent And The Grenadines',
      SM: 'San Marino',
      ST: 'Sao Tome And Principe',
      SA: 'Saudi Arabia',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seychelles',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SX: 'Sint Maarten (Dutch part)',
      SK: 'Slovak Republic',
      SI: 'Slovenia',
      SB: 'Solomon Islands',
      SO: 'Somalia',
      ZA: 'South Africa',
      GS: 'South Georgia And South Sandwich Islands',
      KR: 'South Korea',
      SS: 'South Sudan',
      ES: 'Spain',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Suriname',
      SZ: 'Swaziland',
      SE: 'Sweden',
      CH: 'Switzerland',
      SY: 'Syria',
      TW: 'Taiwan',
      TJ: 'Tajikistan',
      TZ: 'Tanzania',
      TH: 'Thailand',
      TL: 'Timor-Leste',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad And Tobago',
      TN: 'Tunisia',
      TR: 'Turkey',
      TM: 'Turkmenistan',
      TC: 'Turks And Caicos Islands',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukraine',
      AE: 'United Arab Emirates',
      UK: 'United Kingdom',
      US: 'United States',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VA: 'Vatican City (Holy See)',
      VE: 'Venezuela',
      VN: 'Vietnam',
      VG: 'Virgin Islands (British)',
      VI: 'Virgin Islands (US)',
      WF: 'Wallis And Futuna Islands',
      EH: 'Western Sahara',
      WS: 'Western Samoa',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe'
    };
    E.iso_list = {
      AF: 'Afghanistan',
      AX: 'Aland Islands',
      AL: 'Albania',
      DZ: 'Algeria',
      AS: 'American Samoa',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarctica',
      AG: 'Antigua And Barbuda',
      AR: 'Argentina',
      AM: 'Armenia',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbaijan',
      BS: 'Bahamas',
      BH: 'Bahrain',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Belarus',
      BE: 'Belgium',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BO: 'Bolivia',
      BA: ['Bosnia And Herzegovina', 'Bosnia and Herzegovina'],
      BW: 'Botswana',
      BV: 'Bouvet Island',
      BR: 'Brazil',
      IO: 'British Indian Ocean Territory',
      BN: 'Brunei Darussalam',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambodia',
      CM: 'Cameroon',
      CA: 'Canada',
      CV: ['Cape Verde', 'Cabo Verde'],
      CW: 'Curacao',
      KY: 'Cayman Islands',
      CF: 'Central African Republic',
      TD: 'Chad',
      CL: 'Chile',
      CN: 'China',
      CX: 'Christmas Island',
      CC: 'Cocos (Keeling) Islands',
      CO: 'Colombia',
      KM: 'Comoros',
      CG: 'Congo',
      CD: 'Congo, Democratic Republic',
      CK: 'Cook Islands',
      CR: 'Costa Rica',
      CI: ['Cote D\'Ivoire', 'Côte d\'Ivoire'],
      HR: 'Croatia',
      CU: 'Cuba',
      CY: 'Cyprus',
      CZ: 'Czech Republic',
      DK: 'Denmark',
      DJ: 'Djibouti',
      DM: 'Dominica',
      DO: 'Dominican Republic',
      EC: 'Ecuador',
      EG: 'Egypt',
      SV: 'El Salvador',
      GQ: 'Equatorial Guinea',
      ER: 'Eritrea',
      EE: 'Estonia',
      ET: 'Ethiopia',
      FK: 'Falkland Islands (Malvinas)',
      FO: 'Faroe Islands',
      FJ: 'Fiji',
      FI: 'Finland',
      FR: 'France',
      GF: 'French Guiana',
      PF: 'French Polynesia',
      TF: 'French Southern Territories',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      DE: 'Germany',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GR: 'Greece',
      GL: 'Greenland',
      GD: 'Grenada',
      GP: 'Guadeloupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Heard Island & Mcdonald Islands',
      VA: 'Holy See (Vatican City State)',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Hungary',
      IS: 'Iceland',
      IN: 'India',
      ID: 'Indonesia',
      IR: ['Iran, Islamic Republic Of', 'Iran, Islamic Republic of'],
      IQ: 'Iraq',
      IE: 'Ireland',
      IM: 'Isle Of Man',
      IL: 'Israel',
      IT: 'Italy',
      JM: 'Jamaica',
      JP: 'Japan',
      JE: 'Jersey',
      JO: 'Jordan',
      KZ: 'Kazakhstan',
      KE: 'Kenya',
      KI: 'Kiribati',
      KR: ['Korea', 'Korea, Republic of', 'Republic of Korea'],
      KW: 'Kuwait',
      KG: 'Kyrgyzstan',
      LA: 'Lao People\'s Democratic Republic',
      LV: 'Latvia',
      LB: 'Lebanon',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libyan Arab Jamahiriya',
      LI: 'Liechtenstein',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      MO: 'Macao',
      MK: 'Macedonia',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malaysia',
      MV: 'Maldives',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Marshall Islands',
      MQ: 'Martinique',
      MR: 'Mauritania',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Mexico',
      FM: 'Micronesia, Federated States Of',
      MD: 'Moldova, Republic of',
      MC: 'Monaco',
      MN: 'Mongolia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Morocco',
      MZ: 'Mozambique',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Netherlands',
      AN: 'Netherlands Antilles',
      NC: 'New Caledonia',
      NZ: 'New Zealand',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Norfolk Island',
      MP: 'Northern Mariana Islands',
      NO: 'Norway',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: ['Palestinian Territory, Occupied', 'Palestine'],
      PA: 'Panama',
      PG: 'Papua New Guinea',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Philippines',
      PN: 'Pitcairn',
      PL: 'Poland',
      PT: 'Portugal',
      PR: 'Puerto Rico',
      QA: 'Qatar',
      RE: 'Reunion',
      RO: 'Romania',
      RU: 'Russian Federation',
      RW: 'Rwanda',
      BL: 'Saint Barthelemy',
      SH: 'Saint Helena',
      KN: 'Saint Kitts And Nevis',
      LC: 'Saint Lucia',
      MF: 'Saint Martin',
      PM: 'Saint Pierre And Miquelon',
      VC: 'Saint Vincent And Grenadines',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Sao Tome And Principe',
      SA: 'Saudi Arabia',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seychelles',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SK: 'Slovakia',
      SI: 'Slovenia',
      SB: 'Solomon Islands',
      SO: 'Somalia',
      ZA: 'South Africa',
      GS: 'South Georgia And Sandwich Isl.',
      ES: 'Spain',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Suriname',
      SJ: 'Svalbard And Jan Mayen',
      SZ: 'Swaziland',
      SE: 'Sweden',
      CH: 'Switzerland',
      SY: 'Syrian Arab Republic',
      TW: 'Taiwan',
      TJ: 'Tajikistan',
      TZ: 'Tanzania',
      TH: 'Thailand',
      TL: 'Timor-Leste',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad And Tobago',
      TN: 'Tunisia',
      TR: 'Turkey',
      TM: 'Turkmenistan',
      TC: 'Turks And Caicos Islands',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukraine',
      AE: 'United Arab Emirates',
      GB: ['United Kingdom', 'Great Britain'],
      US: 'United States',
      UM: ['United States Outlying Islands', 'United States Minor Outlying Islands'],
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: ['Viet Nam', 'Vietnam'],
      VG: 'Virgin Islands, British',
      VI: 'Virgin Islands, U.S.',
      WF: 'Wallis And Futuna',
      EH: 'Western Sahara',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe'
    };

    // XXX saarya: merge with list
    E.adj_list = {
      AF: {
        name: 'Afghanistan',
        adj: 'Afghan'
      },
      AX: {
        name: 'Åland Islands',
        adj: 'Åland Island'
      },
      AL: {
        name: 'Albania',
        adj: 'Albanian'
      },
      DZ: {
        name: 'Algeria',
        adj: 'Algerian'
      },
      AS: {
        name: 'American Samoa',
        adj: 'American Samoan'
      },
      AD: {
        name: 'Andorra',
        adj: 'Andorran'
      },
      AO: {
        name: 'Angola',
        adj: 'Angolan'
      },
      AI: {
        name: 'Anguilla',
        adj: 'Anguillan'
      },
      AG: {
        name: 'Antigua and Barbuda',
        adj: 'Antiguan'
      },
      AR: {
        name: 'Argentina',
        adj: 'Argentinian'
      },
      AM: {
        name: 'Armenia',
        adj: 'Armenian'
      },
      AW: {
        name: 'Aruba',
        adj: 'Aruban'
      },
      AU: {
        name: 'Australia',
        adj: 'Australian'
      },
      AT: {
        name: 'Austria',
        adj: 'Austrian'
      },
      AZ: {
        name: 'Azerbaijan',
        adj: 'Azerbaijani'
      },
      BS: {
        name: 'Bahamas',
        adj: 'Bahamian'
      },
      BH: {
        name: 'Bahrain',
        adj: 'Bahraini'
      },
      BD: {
        name: 'Bangladesh',
        adj: 'Bengali'
      },
      BB: {
        name: 'Barbados',
        adj: 'Barbadian'
      },
      BY: {
        name: 'Belarus',
        adj: 'Belarusian'
      },
      BE: {
        name: 'Belgium',
        adj: 'Belgian'
      },
      BZ: {
        name: 'Belize',
        adj: 'Belizean'
      },
      BJ: {
        name: 'Benin',
        adj: 'Beninese'
      },
      BM: {
        name: 'Bermuda',
        adj: 'Bermudan'
      },
      BT: {
        name: 'Bhutan',
        adj: 'Bhutanese'
      },
      BO: {
        name: 'Bolivia',
        adj: 'Bolivian'
      },
      BA: {
        name: 'Bosnia and Herzegovina',
        adj: 'Bosnian'
      },
      BW: {
        name: 'Botswana',
        adj: 'Botswanan'
      },
      BR: {
        name: 'Brazil',
        adj: 'Brazilian'
      },
      BN: {
        name: 'Brunei',
        adj: 'Bruneian'
      },
      BG: {
        name: 'Bulgaria',
        adj: 'Bulgarian'
      },
      BF: {
        name: 'Burkina Faso',
        adj: 'Burkinabé'
      },
      BI: {
        name: 'Burundi',
        adj: 'Burundian'
      },
      CV: {
        name: 'Cabo Verde',
        adj: 'Cabo Verdean'
      },
      KH: {
        name: 'Cambodia',
        adj: 'Cambodian'
      },
      CM: {
        name: 'Cameroon',
        adj: 'Cameroonian'
      },
      CA: {
        name: 'Canada',
        adj: 'Canadian'
      },
      KY: {
        name: 'Cayman Islands',
        adj: 'Caymanian'
      },
      TD: {
        name: 'Chad',
        adj: 'Chadian'
      },
      CL: {
        name: 'Chile',
        adj: 'Chilean'
      },
      CN: {
        name: 'China',
        adj: 'Chinese'
      },
      CX: {
        name: 'Christmas Island',
        adj: 'Christmas Island'
      },
      CO: {
        name: 'Colombia',
        adj: 'Colombian'
      },
      KM: {
        name: 'Comoros',
        adj: 'Comoran'
      },
      CG: {
        name: 'Congo',
        adj: 'Congolese'
      },
      CK: {
        name: 'Cook Islands',
        adj: 'Cook Island'
      },
      CR: {
        name: 'Costa Rica',
        adj: 'Costa Rican'
      },
      CI: {
        name: 'Côte d\'Ivoire',
        adj: 'Ivorian'
      },
      HR: {
        name: 'Croatia',
        adj: 'Croatian'
      },
      CU: {
        name: 'Cuba',
        adj: 'Cuban'
      },
      CW: {
        name: 'Curaçao',
        adj: 'Curaçaoan'
      },
      CY: {
        name: 'Cyprus',
        adj: 'Cypriot'
      },
      CZ: {
        name: 'Czech Republic',
        adj: 'Czech'
      },
      DK: {
        name: 'Denmark',
        adj: 'Danish'
      },
      DJ: {
        name: 'Djibouti',
        adj: 'Djiboutian'
      },
      DM: {
        name: 'Dominica',
        adj: 'Dominican'
      },
      DO: {
        name: 'Dominican Republic',
        adj: 'Dominican'
      },
      EC: {
        name: 'Ecuador',
        adj: 'Ecuadorian'
      },
      EG: {
        name: 'Egypt',
        adj: 'Egyptian'
      },
      SV: {
        name: 'El Salvador',
        adj: 'Salvadoran'
      },
      GQ: {
        name: 'Equatorial Guinea',
        adj: 'Equatorial Guinean'
      },
      EE: {
        name: 'Estonia',
        adj: 'Estonian'
      },
      ET: {
        name: 'Ethiopia',
        adj: 'Ethiopian'
      },
      FO: {
        name: 'Faroe Islands',
        adj: 'Faroese'
      },
      FJ: {
        name: 'Fiji',
        adj: 'Fijian'
      },
      FI: {
        name: 'Finland',
        adj: 'Finnish'
      },
      FR: {
        name: 'France',
        adj: 'French'
      },
      PF: {
        name: 'French Polynesia',
        adj: 'French Polynesian'
      },
      GA: {
        name: 'Gabon',
        adj: 'Gabonese'
      },
      GM: {
        name: 'Gambia',
        adj: 'Gambian'
      },
      GE: {
        name: 'Georgia',
        adj: 'Georgian'
      },
      DE: {
        name: 'Germany',
        adj: 'German'
      },
      GH: {
        name: 'Ghana',
        adj: 'Ghanaian'
      },
      GI: {
        name: 'Gibraltar',
        adj: 'Gibraltar'
      },
      GR: {
        name: 'Greece',
        adj: 'Greek'
      },
      GL: {
        name: 'Greenland',
        adj: 'Greenlandic'
      },
      GD: {
        name: 'Grenada',
        adj: 'Grenadian'
      },
      GU: {
        name: 'Guam',
        adj: 'Guamanian'
      },
      GT: {
        name: 'Guatemala',
        adj: 'Guatemalan'
      },
      GG: {
        name: 'Guernsey',
        adj: 'Channel Island'
      },
      GN: {
        name: 'Guinea',
        adj: 'Guinean'
      },
      GW: {
        name: 'Guinea-Bissau',
        adj: 'Bissau-Guinean'
      },
      GY: {
        name: 'Guyana',
        adj: 'Guyanese'
      },
      HT: {
        name: 'Haiti',
        adj: 'Haitian'
      },
      HN: {
        name: 'Honduras',
        adj: 'Honduran'
      },
      HK: {
        name: 'Hong Kong',
        adj: 'Hong Kong'
      },
      HU: {
        name: 'Hungary',
        adj: 'Hungarian'
      },
      IS: {
        name: 'Iceland',
        adj: 'Icelandic'
      },
      IN: {
        name: 'India',
        adj: 'Indian'
      },
      ID: {
        name: 'Indonesia',
        adj: 'Indonesian'
      },
      IR: {
        name: 'Iran',
        adj: 'Iranian'
      },
      IQ: {
        name: 'Iraq',
        adj: 'Iraqi'
      },
      IE: {
        name: 'Ireland',
        adj: 'Irish'
      },
      IM: {
        name: 'Isle of Man',
        adj: 'Manx'
      },
      IL: {
        name: 'Israel',
        adj: 'Israeli'
      },
      IT: {
        name: 'Italy',
        adj: 'Italian'
      },
      JM: {
        name: 'Jamaica',
        adj: 'Jamaican'
      },
      JP: {
        name: 'Japan',
        adj: 'Japanese'
      },
      JE: {
        name: 'Jersey',
        adj: 'Channel Island'
      },
      JO: {
        name: 'Jordan',
        adj: 'Jordanian'
      },
      KZ: {
        name: 'Kazakhstan',
        adj: 'Kazakhstani'
      },
      KE: {
        name: 'Kenya',
        adj: 'Kenyan'
      },
      KI: {
        name: 'Kiribati',
        adj: 'I-Kiribati'
      },
      KW: {
        name: 'Kuwait',
        adj: 'Kuwaiti'
      },
      KG: {
        name: 'Kyrgyzstan',
        adj: 'Kyrgyzstani'
      },
      LA: {
        name: 'Laos',
        adj: 'Lao, Laotian'
      },
      LV: {
        name: 'Latvia',
        adj: 'Latvian'
      },
      LB: {
        name: 'Lebanon',
        adj: 'Lebanese'
      },
      LS: {
        name: 'Lesotho',
        adj: 'Basotho'
      },
      LR: {
        name: 'Liberia',
        adj: 'Liberian'
      },
      LY: {
        name: 'Libya',
        adj: 'Libyan'
      },
      LI: {
        name: 'Liechtenstein',
        adj: 'Liechtensteiner'
      },
      LT: {
        name: 'Lithuania',
        adj: 'Lithuanian'
      },
      LU: {
        name: 'Luxembourg',
        adj: 'Luxembourgish'
      },
      MO: {
        name: 'Macau',
        adj: 'Macanese'
      },
      MK: {
        name: 'Macedonia',
        adj: 'Macedonian'
      },
      MG: {
        name: 'Madagascar',
        adj: 'Malagasy'
      },
      MW: {
        name: 'Malawi',
        adj: 'Malawian'
      },
      MY: {
        name: 'Malaysia',
        adj: 'Malaysian'
      },
      MV: {
        name: 'Maldives',
        adj: 'Maldivian'
      },
      ML: {
        name: 'Mali',
        adj: 'Malian'
      },
      MT: {
        name: 'Malta',
        adj: 'Maltese'
      },
      MH: {
        name: 'Marshall Islands',
        adj: 'Marshallese'
      },
      MQ: {
        name: 'Martinique',
        adj: 'Martinican'
      },
      MR: {
        name: 'Mauritania',
        adj: 'Mauritanian'
      },
      MU: {
        name: 'Mauritius',
        adj: 'Mauritian'
      },
      YT: {
        name: 'Mayotte',
        adj: 'Mahoran'
      },
      MX: {
        name: 'Mexico',
        adj: 'Mexican'
      },
      FM: {
        name: 'Micronesia',
        adj: 'Micronesian'
      },
      MD: {
        name: 'Moldova',
        adj: 'Moldovan'
      },
      MC: {
        name: 'Monaco',
        adj: 'Monacan'
      },
      MN: {
        name: 'Mongolia',
        adj: 'Mongolian'
      },
      ME: {
        name: 'Montenegro',
        adj: 'Montenegrin'
      },
      MA: {
        name: 'Morocco',
        adj: 'Moroccan'
      },
      MZ: {
        name: 'Mozambique',
        adj: 'Mozambican'
      },
      MM: {
        name: 'Myanmar',
        adj: 'Burmese'
      },
      NA: {
        name: 'Namibia',
        adj: 'Namibian'
      },
      NR: {
        name: 'Nauru',
        adj: 'Nauruan'
      },
      NP: {
        name: 'Nepal',
        adj: 'Nepali'
      },
      NL: {
        name: 'Netherlands',
        adj: 'Dutch'
      },
      NC: {
        name: 'New Caledonia',
        adj: 'New Caledonian'
      },
      NZ: {
        name: 'New Zealand',
        adj: 'Zelanian'
      },
      NI: {
        name: 'Nicaragua',
        adj: 'Nicaraguan'
      },
      NE: {
        name: 'Niger',
        adj: 'Nigerien'
      },
      NG: {
        name: 'Nigeria',
        adj: 'Nigerian'
      },
      MP: {
        name: 'Northern Mariana Islands',
        adj: 'Niuean'
      },
      NO: {
        name: 'Norway',
        adj: 'Norwegian'
      },
      OM: {
        name: 'Oman',
        adj: 'Omani'
      },
      PK: {
        name: 'Pakistan',
        adj: 'Pakistani'
      },
      PW: {
        name: 'Palau',
        adj: 'Palauan'
      },
      PS: {
        name: 'Palestine',
        adj: 'Palestinian'
      },
      PA: {
        name: 'Panama',
        adj: 'Panamanian'
      },
      PG: {
        name: 'Papua New Guinea',
        adj: 'Papuan'
      },
      PY: {
        name: 'Paraguay',
        adj: 'Paraguayan'
      },
      PE: {
        name: 'Peru',
        adj: 'Peruvian'
      },
      PH: {
        name: 'Philippines',
        adj: 'Filipino'
      },
      PL: {
        name: 'Poland',
        adj: 'Polish'
      },
      PT: {
        name: 'Portugal',
        adj: 'Portuguese'
      },
      PR: {
        name: 'Puerto Rico',
        adj: 'Puerto Rican'
      },
      QA: {
        name: 'Qatar',
        adj: 'Qatari'
      },
      RO: {
        name: 'Romania',
        adj: 'Romanian'
      },
      RU: {
        name: 'Russia',
        adj: 'Russian'
      },
      RW: {
        name: 'Rwanda',
        adj: 'Rwandan'
      },
      BL: {
        name: 'Saint Barthélemy',
        adj: 'Barthélemois'
      },
      KN: {
        name: 'Saint Kitts and Nevis',
        adj: 'Kittitian'
      },
      LC: {
        name: 'Saint Lucia',
        adj: 'Saint Lucian'
      },
      MF: {
        name: 'Saint Martin',
        adj: 'Saint-Martinoise'
      },
      VC: {
        name: 'Saint Vincent and the Grenadines',
        adj: 'Saint Vincentian'
      },
      SM: {
        name: 'San Marino',
        adj: 'Sammarinese'
      },
      SA: {
        name: 'Saudi Arabia',
        adj: 'Saudi'
      },
      SN: {
        name: 'Senegal',
        adj: 'Senegalese'
      },
      RS: {
        name: 'Serbia',
        adj: 'Serbian'
      },
      SC: {
        name: 'Seychelles',
        adj: 'Seychellois'
      },
      SL: {
        name: 'Sierra Leone',
        adj: 'Sierra Leonean'
      },
      SG: {
        name: 'Singapore',
        adj: 'Singaporean'
      },
      SK: {
        name: 'Slovakia',
        adj: 'Slovak'
      },
      SI: {
        name: 'Slovenia',
        adj: 'Slovenian'
      },
      SB: {
        name: 'Solomon Islands',
        adj: 'Solomon Island'
      },
      SO: {
        name: 'Somalia',
        adj: 'Somali'
      },
      ZA: {
        name: 'South Africa',
        adj: 'South African'
      },
      KR: {
        name: 'South Korea',
        adj: 'South Korean'
      },
      SS: {
        name: 'South Sudan',
        adj: 'South Sudanese'
      },
      ES: {
        name: 'Spain',
        adj: 'Spanish'
      },
      LK: {
        name: 'Sri Lanka',
        adj: 'Sri Lankan'
      },
      SD: {
        name: 'Sudan',
        adj: 'Sudanese'
      },
      SR: {
        name: 'Surinam',
        adj: 'Surinamese'
      },
      SZ: {
        name: 'Swaziland',
        adj: 'Swazi'
      },
      SE: {
        name: 'Sweden',
        adj: 'Swedish'
      },
      CH: {
        name: 'Switzerland',
        adj: 'Swiss'
      },
      SY: {
        name: 'Syria',
        adj: 'Syrian'
      },
      TW: {
        name: 'Taiwan',
        adj: 'Taiwanese'
      },
      TJ: {
        name: 'Tajikistan',
        adj: 'Tajikistani'
      },
      TZ: {
        name: 'Tanzania',
        adj: 'Tanzanian'
      },
      TH: {
        name: 'Thailand',
        adj: 'Thai'
      },
      TL: {
        name: 'Timor-Leste',
        adj: 'Timorese'
      },
      TG: {
        name: 'Togo',
        adj: 'Togolese'
      },
      TT: {
        name: 'Trinidad and Tobago',
        adj: 'Trinidadian'
      },
      TN: {
        name: 'Tunisia',
        adj: 'Tunisian'
      },
      TR: {
        name: 'Turkey',
        adj: 'Turkish'
      },
      TC: {
        name: 'Turks and Caicos Islands',
        adj: 'Turks and Caicos Island'
      },
      UG: {
        name: 'Uganda',
        adj: 'Ugandan'
      },
      UA: {
        name: 'Ukraine',
        adj: 'Ukrainian'
      },
      AE: {
        name: 'United Arab Emirates',
        adj: 'Emirati'
      },
      GB: {
        name: 'United Kingdom',
        adj: 'British'
      },
      US: {
        name: 'United States',
        adj: 'American'
      },
      UY: {
        name: 'Uruguay',
        adj: 'Uruguayan'
      },
      UZ: {
        name: 'Uzbekistan',
        adj: 'Uzbekistani'
      },
      VU: {
        name: 'Vanuatu',
        adj: 'Vanuatuan'
      },
      VE: {
        name: 'Venezuela',
        adj: 'Venezuelan'
      },
      VN: {
        name: 'Vietnam',
        adj: 'Vietnamese'
      },
      VG: {
        name: 'Virgin Islands, British',
        adj: 'British Virgin Island'
      },
      VI: {
        name: 'Virgin Islands, United States',
        adj: 'U.S. Virgin Island'
      },
      YE: {
        name: 'Yemen',
        adj: 'Yemeni'
      },
      ZM: {
        name: 'Zambia',
        adj: 'Zambian'
      },
      ZW: {
        name: 'Zimbabwe',
        adj: 'Zimbabwean'
      }
    };
    E.extra_adj_list = {
      WS: {
        name: 'Western Samoa',
        adj: 'Samoan'
      },
      CD: {
        name: 'Democratic Republic of the Congo',
        adj: 'Congolese'
      },
      ST: {
        name: 'São Tomé and Príncipe',
        adj: 'Santomean'
      },
      TO: {
        name: 'Tonga',
        adj: 'Tongan'
      },
      TM: {
        name: 'Turkmenistan',
        adj: 'Turkmen'
      },
      CF: {
        name: 'Central African Republic',
        adj: 'Central African'
      },
      TV: {
        name: 'Tuvalu',
        adj: 'Tuvaluan'
      }
    };
    E.countries_meta = {
      AE: {
        meta_title: 'UAE VPN - Secure Emirati IP, Fast & Free Access',
        meta_description: 'Use a trusted UAE VPN for secure, private browsing. Get an Emirati IP address, unblock content, and enjoy fast, encrypted access from anywhere.'
      },
      IN: {
        meta_title: 'India VPN - Get a Free, Private Indian IP',
        meta_description: 'Bypass geo-blocks and stay private online. Hola offers the best free VPN for India with fast, secure servers and unrestricted Indian content access.'
      },
      JP: {
        meta_title: 'Try Free Japan VPN - Get a Secure Japanese IP',
        meta_description: 'Browse with privacy using the best Japanese VPN. Hola\'s VPN for Japan offers fast, secure connections with Japanese IPs - totally free.'
      },
      GB: {
        meta_title: 'UK VPN - Fast, Secure British IP Access',
        meta_description: 'Browse securely with the best UK VPN. Hola offers fast, private access to UK sites and apps. Get a British VPN with high-speed, premium connections.'
      },
      CN: {
        meta_title: 'Best VPN for China - Fast & Reliable Access',
        meta_description: 'Use a trusted VPN for China to access content and services. Enjoy fast, secure browsing wherever you are with total online freedom.'
      },
      TR: {
        meta_title: 'Turkey VPN - Free Turkish IP & Safe Browsing',
        meta_description: 'Try the best free Turkey VPN for private, fast, and secure browsing. Get a Turkish VPN with unlimited access and no restrictions—completely free.'
      },
      MY: {
        meta_title: 'Malaysia VPN - Fast & Private Malaysian IP',
        meta_description: 'Browse securely with a reliable Malaysia VPN. Get a private Malaysian IP address, access local content, and stay protected with fast, stable connections.'
      },
      SG: {
        meta_title: 'Best VPN for Singapore - Private, High-Speed Access',
        meta_description: 'Get private, high-speed access with a trusted Singapore VPN. Browse securely, stream content, and connect to a local Singapore IP from anywhere.'
      },
      EG: {
        meta_title: 'Egypt VPN - Secure, Private Egyptian IP Access',
        meta_description: 'Stay safe online with a trusted Egypt VPN. Access local websites, browse privately, and enjoy fast, encrypted connections from anywhere in the world.'
      },
      PH: {
        meta_title: 'Best VPN for Philippines - Private & Reliable',
        meta_description: 'Browse safely with a trusted Philippines VPN. Get a fast, secure Philippine IP address and access local content from anywhere with complete privacy.'
      },
      CA: {
        meta_title: 'Free Canada VPN - Fast & Private Canadian IP',
        meta_description: 'Enjoy secure browsing with a free Canada VPN. Get a Canadian IP, unblock websites, and protect your privacy with fast, unlimited VPN access.'
      },
      US: {
        meta_title: 'Best USA VPN - Secure, Fast American IP',
        meta_description: 'Browse securely with a high-speed USA VPN. Get a reliable American IP address and access US content with encrypted, premium connections.'
      },
      TH: {
        meta_title: 'Thailand VPN - Secure Thai IP, Fast & Private',
        meta_description: 'Browse privately with a reliable Thailand VPN. Get a Thai IP address, unblock local content, and protect your data with fast, encrypted access.'
      },
      PK: {
        meta_title: 'Pakistan VPN - Fast & Private Pakistani IP',
        meta_description: 'Browse privately with a secure Pakistan VPN. Get a fast Pakistani IP address, access local content, and stay protected online with encrypted connections.'
      },
      CI: {
        meta_title: 'Côte d\'Ivoire VPN - Secure Ivorian IP, Fast & Reliable',
        meta_description: 'Browse securely with a trusted Ivory Coast VPN. Get an Ivorian IP address, access local content, and enjoy fast, private connections.'
      },
      ID: {
        meta_title: 'Indonesia VPN - Private & Reliable Indonesian IP',
        meta_description: 'Stay safe online with a reliable Indonesia VPN. Get an Indonesian IP, access local sites, and browse securely with fast, private connections.'
      },
      AR: {
        meta_title: 'Argentina VPN - Get a Free, Secure Argentine IP',
        meta_description: 'Browse securely with a fast Argentina VPN. Get an Argentinian IP address, unblock local content, and protect your privacy online.'
      },
      BR: {
        meta_title: 'Brazil VPN - Fast & Private Brazilian IP Access',
        meta_description: 'Enjoy private browsing with a trusted Brazil VPN. Get a Brazilian IP, access local content, and stay secure with fast, encrypted connections.'
      },
      RU: {
        meta_title: 'Russia VPN - Secure Russian IP, Fast & Reliable',
        meta_description: 'Use a reliable Russia VPN for private, secure browsing. Get a Russian IP address, unblock content, and enjoy fast, encrypted access online.'
      },
      AU: {
        meta_title: 'Australia VPN - Private Aussie IP, Fast & Secure',
        meta_description: 'Browse with privacy using a secure Australia VPN. Get an Australian IP, access local content, and enjoy fast, stable connections from anywhere.'
      },
      NG: {
        meta_title: 'Nigeria VPN - Free Nigerian IP, Secure & Private',
        meta_description: 'Get private, high-speed access with a trusted Nigeria VPN. Browse securely, stream local content, and connect to a Nigerian IP from anywhere.'
      },
      BD: {
        meta_title: 'Bangladesh VPN - Fast & Private Bangladeshi IP',
        meta_description: 'Browse safely with a secure Bangladesh VPN. Get a Bangladeshi IP address, access local content, and protect your privacy with fast, encrypted connections.'
      },
      NZ: {
        meta_title: 'New Zealand VPN - Secure Kiwi IP, Fast & Private',
        meta_description: 'Enjoy secure browsing with a reliable New Zealand VPN. Get a Kiwi IP address, unblock content, and stay private with fast, stable connections.'
      },
      VN: {
        meta_title: 'Vietnam VPN - Fast & Secure Vietnamese IP Access',
        meta_description: 'Stay protected online with a fast Vietnam VPN. Get a Vietnamese IP, access local content, and browse securely with encrypted connections.'
      },
      TW: {
        meta_title: 'Taiwan VPN - Private Taiwanese IP, Fast & Reliable',
        meta_description: 'Use a trusted Taiwan VPN for private, secure browsing. Get a Taiwanese IP address, unblock local sites, and enjoy fast, encrypted access.'
      },
      IR: {
        meta_title: 'Iran VPN - Secure Iranian IP, Private & Fast',
        meta_description: 'Browse securely with a reliable Iran VPN. Get an Iranian IP address, access local content, and stay private with fast, encrypted connections.'
      },
      DE: {
        meta_title: 'Germany VPN - Fast & Private German IP Access',
        meta_description: 'Get fast, private access with a secure Germany VPN. Browse with a German IP, unblock local content, and protect your data online.'
      },
      UA: {
        meta_title: 'Ukraine VPN - Secure Ukrainian IP, Fast & Free',
        meta_description: 'Enjoy private browsing with a trusted Ukraine VPN. Get a Ukrainian IP address, access local content, and stay secure with fast, encrypted connections.'
      },
      MX: {
        meta_title: 'Mexico VPN - Private Mexican IP, Fast & Reliable',
        meta_description: 'Browse securely with a trusted Mexico VPN. Get a Mexican IP address, access local content, and protect your privacy with fast, encrypted connections.'
      },
      MM: {
        meta_title: 'Myanmar VPN - Free Burmese IP, Secure & Private',
        meta_description: 'Use a reliable Myanmar VPN for private, secure browsing. Get a Burmese IP, unblock content, and enjoy fast, encrypted access.'
      },
      FR: {
        meta_title: 'France VPN - Fast & Secure French IP Access',
        meta_description: 'Enjoy private browsing with a secure France VPN. Get a French IP address, access local content, and stay protected with fast, stable connections.'
      },
      SA: {
        meta_title: 'Saudi Arabia VPN - Private Saudi IP, Fast & Secure',
        meta_description: 'Browse safely with a trusted Saudi Arabia VPN. Get a Saudi IP address, unblock local sites, and protect your privacy online.'
      },
      HK: {
        meta_title: 'Hong Kong VPN - Secure HK IP, Fast & Private Access',
        meta_description: 'Use a secure Hong Kong VPN for private, fast browsing. Get a Hong Kong IP, access local content, and stay protected online.'
      },
      IT: {
        meta_title: 'Italy VPN - Fast & Private Italian IP Access',
        meta_description: 'Get fast, private access with a trusted Italy VPN. Browse with an Italian IP, unblock content, and protect your data with encrypted connections.'
      },
      IL: {
        meta_title: 'Israel VPN - Secure Israeli IP, Fast & Reliable',
        meta_description: 'Browse securely with a reliable Israel VPN. Get an Israeli IP address, access local content, and enjoy fast, encrypted browsing.'
      },
      ES: {
        meta_title: 'Spain VPN - Private Spanish IP, Fast & Secure',
        meta_description: 'Enjoy private browsing with a fast Spain VPN. Get a Spanish IP, unblock local content, and stay secure with encrypted connections.'
      },
      GR: {
        meta_title: 'Greece VPN - Secure Greek IP, Fast & Private',
        meta_description: 'Use a trusted Greece VPN for secure, private browsing. Get a Greek IP address, access local content, and enjoy fast, encrypted access.'
      },
      ZA: {
        meta_title: 'South Africa VPN - Fast & Secure South African IP',
        meta_description: 'Browse safely with a reliable South Africa VPN. Get a South African IP, unblock local content, and protect your privacy online.'
      },
      QA: {
        meta_title: 'Qatar VPN - Private Qatari IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Qatar VPN. Browse with a Qatari IP, unblock content, and stay protected online.'
      },
      TD: {
        meta_title: 'Chad VPN - Secure Chadian IP, Fast & Private',
        meta_description: 'Use a trusted Chad VPN for secure, private browsing. Get a Chadian IP address, access local content, and enjoy fast, encrypted connections.'
      },
      CO: {
        meta_title: 'Colombia VPN - Fast & Private Colombian IP Access',
        meta_description: 'Browse securely with a reliable Colombia VPN. Get a Colombian IP, unblock local content, and protect your privacy online.'
      },
      NP: {
        meta_title: 'Nepal VPN - Secure Nepali IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Nepal VPN. Get a Nepali IP address, access local content, and stay protected with fast, encrypted connections.'
      },
      KR: {
        meta_title: 'South Korea VPN - Fast Korean IP, Secure & Private',
        meta_description: 'Use a trusted South Korea VPN for fast, private browsing. Get a Korean IP, access local content, and stay secure online.'
      },
      AW: {
        meta_title: 'Aruba VPN - Private Aruban IP, Fast & Secure',
        meta_description: 'Browse safely with a reliable Aruba VPN. Get an Aruban IP address, unblock content, and enjoy private, encrypted access.'
      },
      PL: {
        meta_title: 'Poland VPN - Secure Polish IP, Fast & Private',
        meta_description: 'Get fast, secure access with a trusted Poland VPN. Browse with a Polish IP, unblock local content, and protect your privacy online.'
      },
      NO: {
        meta_title: 'Norway VPN - Fast & Private Norwegian IP Access',
        meta_description: 'Use a secure Norway VPN for private, fast browsing. Get a Norwegian IP address, access local content, and stay protected online.'
      },
      KP: {
        meta_title: 'North Korea VPN - Secure Korean IP, Private Access',
        meta_description: 'Browse securely with a North Korea VPN. Get a North Korean IP address, access content, and stay private with encrypted connections.'
      },
      SE: {
        meta_title: 'Sweden VPN - Fast & Secure Swedish IP Access',
        meta_description: 'Enjoy private browsing with a fast Sweden VPN. Get a Swedish IP, unblock local content, and protect your data online.'
      },
      CH: {
        meta_title: 'Switzerland VPN - Private Swiss IP, Fast & Secure',
        meta_description: 'Use a trusted Switzerland VPN for secure, private browsing. Get a Swiss IP address, access local content, and enjoy fast, encrypted connections.'
      },
      KZ: {
        meta_title: 'Kazakhstan VPN - Secure Kazakh IP, Fast & Private',
        meta_description: 'Browse safely with a reliable Kazakhstan VPN. Get a Kazakh IP address, unblock content, and stay protected online.'
      },
      AT: {
        meta_title: 'Austria VPN - Fast & Private Austrian IP Access',
        meta_description: 'Get private, high-speed access with a secure Austria VPN. Browse with an Austrian IP, access local content, and protect your privacy.'
      },
      IE: {
        meta_title: 'Ireland VPN - Secure Irish IP, Fast & Reliable',
        meta_description: 'Use a trusted Ireland VPN for fast, secure browsing. Get an Irish IP address, unblock content, and stay private online.'
      },
      PT: {
        meta_title: 'Portugal VPN - Private Portuguese IP, Fast & Secure',
        meta_description: 'Browse securely with a reliable Portugal VPN. Get a Portuguese IP address, access local content, and enjoy encrypted connections.'
      },
      CL: {
        meta_title: 'Chile VPN - Fast & Secure Chilean IP Access',
        meta_description: 'Enjoy private browsing with a secure Chile VPN. Get a Chilean IP, unblock content, and stay protected with fast, encrypted access.'
      },
      KW: {
        meta_title: 'Kuwait VPN - Private Kuwaiti IP, Fast & Reliable',
        meta_description: 'Use a trusted Kuwait VPN for secure, private browsing. Get a Kuwaiti IP address, access local content, and enjoy fast, encrypted connections.'
      },
      GH: {
        meta_title: 'Ghana VPN - Secure Ghanaian IP, Fast & Private',
        meta_description: 'Browse safely with a reliable Ghana VPN. Get a Ghanaian IP address, unblock content, and protect your privacy online.'
      },
      NL: {
        meta_title: 'Netherlands VPN - Fast Dutch IP, Secure & Private',
        meta_description: 'Get fast, private access with a secure Netherlands VPN. Browse with a Dutch IP, unblock content, and stay protected online.'
      },
      KE: {
        meta_title: 'Kenya VPN - Secure Kenyan IP, Fast & Reliable',
        meta_description: 'Use a trusted Kenya VPN for secure, private browsing. Get a Kenyan IP address, access local content, and enjoy fast, encrypted connections.'
      },
      LK: {
        meta_title: 'Sri Lanka VPN - Private Sri Lankan IP, Fast & Secure',
        meta_description: 'Browse securely with a reliable Sri Lanka VPN. Get a Sri Lankan IP, unblock content, and protect your privacy online.'
      },
      DZ: {
        meta_title: 'Algeria VPN - Fast & Secure Algerian IP Access',
        meta_description: 'Enjoy private browsing with a secure Algeria VPN. Get an Algerian IP address, access local content, and stay protected online.'
      },
      AL: {
        meta_title: 'Albania VPN - Private Albanian IP, Fast & Secure',
        meta_description: 'Use a trusted Albania VPN for fast, secure browsing. Get an Albanian IP address, unblock content, and protect your privacy.'
      },
      GE: {
        meta_title: 'Georgia VPN - Secure Georgian IP, Fast & Private',
        meta_description: 'Browse safely with a reliable Georgia VPN. Get a Georgian IP address, access local content, and enjoy encrypted connections.'
      },
      RO: {
        meta_title: 'Romania VPN - Fast & Private Romanian IP Access',
        meta_description: 'Get private, high-speed access with a secure Romania VPN. Browse with a Romanian IP, unblock content, and stay protected online.'
      },
      DM: {
        meta_title: 'Dominica VPN - Secure Dominican IP, Fast & Private',
        meta_description: 'Use a trusted Dominica VPN for secure, private browsing. Get a Dominican IP address, access local content, and enjoy fast, encrypted access.'
      },
      AZ: {
        meta_title: 'Azerbaijan VPN - Fast & Private Azerbaijani IP',
        meta_description: 'Browse securely with a reliable Azerbaijan VPN. Get an Azerbaijani IP address, unblock content, and protect your privacy online.'
      },
      IQ: {
        meta_title: 'Iraq VPN - Secure Iraqi IP, Fast & Reliable Access',
        meta_description: 'Enjoy private browsing with a secure Iraq VPN. Get an Iraqi IP address, access local content, and stay protected with encrypted connections.'
      },
      PE: {
        meta_title: 'Peru VPN - Private Peruvian IP, Fast & Secure',
        meta_description: 'Use a trusted Peru VPN for fast, secure browsing. Get a Peruvian IP address, unblock content, and protect your privacy online.'
      },
      BE: {
        meta_title: 'Belgium VPN - Fast & Secure Belgian IP Access',
        meta_description: 'Browse safely with a reliable Belgium VPN. Get a Belgian IP address, access local content, and enjoy encrypted connections.'
      },
      BG: {
        meta_title: 'Bulgaria VPN - Private Bulgarian IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Bulgaria VPN. Browse with a Bulgarian IP, unblock content, and stay protected online.'
      },
      FI: {
        meta_title: 'Finland VPN - Secure Finnish IP, Fast & Private',
        meta_description: 'Use a trusted Finland VPN for secure, private browsing. Get a Finnish IP address, access local content, and enjoy fast, encrypted access.'
      },
      MA: {
        meta_title: 'Morocco VPN - Fast & Private Moroccan IP Access',
        meta_description: 'Browse securely with a reliable Morocco VPN. Get a Moroccan IP address, unblock content, and protect your privacy online.'
      },
      OM: {
        meta_title: 'Oman VPN - Secure Omani IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Oman VPN. Get an Omani IP address, access local content, and stay protected with encrypted connections.'
      },
      RS: {
        meta_title: 'Serbia VPN - Private Serbian IP, Fast & Secure',
        meta_description: 'Use a trusted Serbia VPN for fast, secure browsing. Get a Serbian IP address, unblock content, and protect your privacy online.'
      },
      KH: {
        meta_title: 'Cambodia VPN - Fast & Secure Cambodian IP Access',
        meta_description: 'Browse safely with a reliable Cambodia VPN. Get a Cambodian IP address, access local content, and enjoy encrypted connections.'
      },
      HU: {
        meta_title: 'Hungary VPN - Private Hungarian IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Hungary VPN. Browse with a Hungarian IP, unblock content, and stay protected online.'
      },
      LV: {
        meta_title: 'Latvia VPN - Secure Latvian IP, Fast & Private',
        meta_description: 'Use a trusted Latvia VPN for secure, private browsing. Get a Latvian IP address, access local content, and enjoy fast, encrypted access.'
      },
      AM: {
        meta_title: 'Armenia VPN - Fast & Private Armenian IP Access',
        meta_description: 'Browse securely with a reliable Armenia VPN. Get an Armenian IP address, unblock content, and protect your privacy online.'
      },
      BH: {
        meta_title: 'Bahrain VPN - Secure Bahraini IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Bahrain VPN. Get a Bahraini IP address, access local content, and stay protected with encrypted connections.'
      },
      LY: {
        meta_title: 'Libya VPN - Private Libyan IP, Fast & Secure',
        meta_description: 'Use a trusted Libya VPN for fast, secure browsing. Get a Libyan IP address, unblock content, and protect your privacy online.'
      },
      LA: {
        meta_title: 'Laos VPN - Fast & Secure Laotian IP Access',
        meta_description: 'Browse safely with a reliable Laos VPN. Get a Laotian IP address, access local content, and enjoy encrypted connections.'
      },
      TN: {
        meta_title: 'Tunisia VPN - Private Tunisian IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Tunisia VPN. Browse with a Tunisian IP, unblock content, and stay protected online.'
      },
      VE: {
        meta_title: 'Venezuela VPN - Secure Venezuelan IP, Fast & Private',
        meta_description: 'Use a trusted Venezuela VPN for secure, private browsing. Get a Venezuelan IP address, access local content, and enjoy fast, encrypted access.'
      },
      PA: {
        meta_title: 'Panama VPN - Fast & Private Panamanian IP Access',
        meta_description: 'Browse securely with a reliable Panama VPN. Get a Panamanian IP address, unblock content, and protect your privacy online.'
      },
      DK: {
        meta_title: 'Denmark VPN - Secure Danish IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Denmark VPN. Get a Danish IP address, access local content, and stay protected with encrypted connections.'
      },
      MN: {
        meta_title: 'Mongolia VPN - Private Mongolian IP, Fast & Secure',
        meta_description: 'Use a trusted Mongolia VPN for fast, secure browsing. Get a Mongolian IP address, unblock content, and protect your privacy online.'
      },
      CY: {
        meta_title: 'Cyprus VPN - Fast & Secure Cypriot IP Access',
        meta_description: 'Browse safely with a reliable Cyprus VPN. Get a Cypriot IP address, access local content, and enjoy encrypted connections.'
      },
      JO: {
        meta_title: 'Jordan VPN - Private Jordanian IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Jordan VPN. Browse with a Jordanian IP, unblock content, and stay protected online.'
      },
      PR: {
        meta_title: 'Puerto Rico VPN - Secure Puerto Rican IP, Fast & Private',
        meta_description: 'Use a trusted Puerto Rico VPN for secure, private browsing. Get a Puerto Rican IP address, access local content, and enjoy fast, encrypted access.'
      },
      IS: {
        meta_title: 'Iceland VPN - Fast & Private Icelandic IP Access',
        meta_description: 'Browse securely with a reliable Iceland VPN. Get an Icelandic IP address, unblock content, and protect your privacy online.'
      },
      MT: {
        meta_title: 'Malta VPN - Secure Maltese IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Malta VPN. Get a Maltese IP address, access local content, and stay protected with encrypted connections.'
      },
      MD: {
        meta_title: 'Moldova VPN - Private Moldovan IP, Fast & Secure',
        meta_description: 'Use a trusted Moldova VPN for fast, secure browsing. Get a Moldovan IP address, unblock content, and protect your privacy online.'
      },
      LT: {
        meta_title: 'Lithuania VPN - Fast & Secure Lithuanian IP Access',
        meta_description: 'Browse safely with a reliable Lithuania VPN. Get a Lithuanian IP address, access local content, and enjoy encrypted connections.'
      },
      AF: {
        meta_title: 'Afghanistan VPN - Private Afghan IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Afghanistan VPN. Browse with an Afghan IP, unblock content, and stay protected online.'
      },
      BY: {
        meta_title: 'Belarus VPN - Secure Belarusian IP, Fast & Private',
        meta_description: 'Use a trusted Belarus VPN for secure, private browsing. Get a Belarusian IP address, access local content, and enjoy fast, encrypted access.'
      },
      HR: {
        meta_title: 'Croatia VPN - Fast & Private Croatian IP Access',
        meta_description: 'Browse securely with a reliable Croatia VPN. Get a Croatian IP address, unblock content, and protect your privacy online.'
      },
      UZ: {
        meta_title: 'Uzbekistan VPN - Secure Uzbek IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Uzbekistan VPN. Get an Uzbek IP address, access local content, and stay protected with encrypted connections.'
      },
      LB: {
        meta_title: 'Lebanon VPN - Private Lebanese IP, Fast & Secure',
        meta_description: 'Use a trusted Lebanon VPN for fast, secure browsing. Get a Lebanese IP address, unblock content, and protect your privacy online.'
      },
      DO: {
        meta_title: 'Dominican Republic VPN - Fast Dominican IP, Secure & Private',
        meta_description: 'Browse safely with a reliable Dominican Republic VPN. Get a Dominican IP address, access local content, and enjoy encrypted connections.'
      },
      BS: {
        meta_title: 'Bahamas VPN - Secure Bahamian IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Bahamas VPN. Browse with a Bahamian IP, unblock content, and stay protected online.'
      },
      EC: {
        meta_title: 'Ecuador VPN - Private Ecuadorian IP, Fast & Secure',
        meta_description: 'Use a trusted Ecuador VPN for secure, private browsing. Get an Ecuadorian IP address, access local content, and enjoy fast, encrypted access.'
      },
      CU: {
        meta_title: 'Cuba VPN - Fast & Secure Cuban IP Access',
        meta_description: 'Browse securely with a reliable Cuba VPN. Get a Cuban IP address, unblock content, and protect your privacy online.'
      },
      EE: {
        meta_title: 'Estonia VPN - Private Estonian IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Estonia VPN. Get an Estonian IP address, access local content, and stay protected with encrypted connections.'
      },
      LU: {
        meta_title: 'Luxembourg VPN - Secure Luxembourg IP, Fast & Private',
        meta_description: 'Use a trusted Luxembourg VPN for fast, secure browsing. Get a Luxembourgish IP address, unblock content, and protect your privacy online.'
      },
      ME: {
        meta_title: 'Montenegro VPN - Fast & Private Montenegrin IP Access',
        meta_description: 'Browse safely with a reliable Montenegro VPN. Get a Montenegrin IP address, access local content, and enjoy encrypted connections.'
      },
      GL: {
        meta_title: 'Greenland VPN - Secure Greenlandic IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Greenland VPN. Browse with a Greenlandic IP, unblock content, and stay protected online.'
      },
      MO: {
        meta_title: 'Macau VPN - Private Macanese IP, Fast & Secure',
        meta_description: 'Use a trusted Macau VPN for secure, private browsing. Get a Macanese IP address, access local content, and enjoy fast, encrypted access.'
      },
      BT: {
        meta_title: 'Bhutan VPN - Fast & Secure Bhutanese IP Access',
        meta_description: 'Browse securely with a reliable Bhutan VPN. Get a Bhutanese IP address, unblock content, and protect your privacy online.'
      },
      SY: {
        meta_title: 'Syria VPN - Private Syrian IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Syria VPN. Get a Syrian IP address, access local content, and stay protected with encrypted connections.'
      },
      UG: {
        meta_title: 'Uganda VPN - Secure Ugandan IP, Fast & Private',
        meta_description: 'Use a trusted Uganda VPN for fast, secure browsing. Get a Ugandan IP address, unblock content, and protect your privacy online.'
      },
      CR: {
        meta_title: 'Costa Rica VPN - Fast & Private Costa Rican IP Access',
        meta_description: 'Browse safely with a reliable Costa Rica VPN. Get a Costa Rican IP address, access local content, and enjoy encrypted connections.'
      },
      SV: {
        meta_title: 'El Salvador VPN - Secure Salvadoran IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure El Salvador VPN. Browse with a Salvadoran IP, unblock content, and stay protected online.'
      },
      GT: {
        meta_title: 'Guatemala VPN - Private Guatemalan IP, Fast & Secure',
        meta_description: 'Use a trusted Guatemala VPN for secure, private browsing. Get a Guatemalan IP address, access local content, and enjoy fast, encrypted access.'
      },
      CZ: {
        meta_title: 'Czech Republic VPN - Fast & Secure Czech IP Access',
        meta_description: 'Browse securely with a reliable Czech VPN. Get a Czech IP address, unblock content, and protect your privacy online.'
      },
      IM: {
        meta_title: 'Isle of Man VPN - Private Manx IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Isle of Man VPN. Get a Manx IP address, access local content, and stay protected with encrypted connections.'
      },
      KI: {
        meta_title: 'Kiribati VPN - Secure Kiribati IP, Fast & Private',
        meta_description: 'Browse securely with a trusted Kiribati VPN. Get a Kiribati IP address, access local content, and enjoy fast, private connections.'
      },
      GY: {
        meta_title: 'Guyana VPN - Fast & Private Guyanese IP Access',
        meta_description: 'Use a reliable Guyana VPN for private, secure browsing. Get a Guyanese IP address, unblock content, and protect your privacy online.'
      },
      SO: {
        meta_title: 'Somalia VPN - Secure Somali IP, Fast & Reliable',
        meta_description: 'Stay protected online with a secure Somalia VPN. Get a Somali IP address, access local content, and browse with encrypted connections.'
      },
      TM: {
        meta_title: 'Turkmenistan VPN - Private Turkmen IP, Fast & Secure',
        meta_description: 'Browse safely with a trusted Turkmenistan VPN. Get a Turkmen IP address, unblock content, and enjoy private, fast browsing.'
      },
      AD: {
        meta_title: 'Andorra VPN - Fast & Secure Andorran IP Access',
        meta_description: 'Get private, high-speed access with a secure Andorra VPN. Browse with an Andorran IP, access local content, and stay protected online.'
      },
      HN: {
        meta_title: 'Honduras VPN - Private Honduran IP, Fast & Reliable',
        meta_description: 'Use a trusted Honduras VPN for secure, private browsing. Get a Honduran IP address, unblock content, and enjoy fast, encrypted access.'
      },
      SI: {
        meta_title: 'Slovenia VPN - Secure Slovenian IP, Fast & Private',
        meta_description: 'Browse securely with a reliable Slovenia VPN. Get a Slovenian IP address, access local content, and protect your privacy online.'
      },
      BN: {
        meta_title: 'Brunei VPN - Fast & Private Bruneian IP Access',
        meta_description: 'Enjoy private browsing with a secure Brunei VPN. Get a Bruneian IP address, unblock content, and stay protected with encrypted connections.'
      },
      ET: {
        meta_title: 'Ethiopia VPN - Secure Ethiopian IP, Fast & Reliable',
        meta_description: 'Use a trusted Ethiopia VPN for fast, secure browsing. Get an Ethiopian IP address, access local content, and protect your privacy online.'
      },
      TZ: {
        meta_title: 'Tanzania VPN - Private Tanzanian IP, Fast & Secure',
        meta_description: 'Browse safely with a reliable Tanzania VPN. Get a Tanzanian IP address, unblock content, and enjoy encrypted connections.'
      },
      BO: {
        meta_title: 'Bolivia VPN - Fast & Secure Bolivian IP Access',
        meta_description: 'Get private, high-speed access with a secure Bolivia VPN. Browse with a Bolivian IP, access local content, and stay protected online.'
      },
      MU: {
        meta_title: 'Mauritius VPN - Private Mauritian IP, Fast & Reliable',
        meta_description: 'Use a trusted Mauritius VPN for secure, private browsing. Get a Mauritian IP address, access local content, and enjoy fast, encrypted access.'
      },
      PS: {
        meta_title: 'Palestine VPN - Secure Palestinian IP, Fast & Private',
        meta_description: 'Browse securely with a reliable Palestine VPN. Get a Palestinian IP address, unblock content, and protect your privacy online.'
      },
      JM: {
        meta_title: 'Jamaica VPN - Fast & Private Jamaican IP Access',
        meta_description: 'Enjoy private browsing with a secure Jamaica VPN. Get a Jamaican IP address, access local content, and stay protected with encrypted connections.'
      },
      MK: {
        meta_title: 'North Macedonia VPN - Secure Macedonian IP, Fast & Reliable',
        meta_description: 'Use a trusted Macedonia VPN for fast, secure browsing. Get a Macedonian IP address, unblock content, and protect your privacy online.'
      },
      KG: {
        meta_title: 'Kyrgyzstan VPN - Private Kyrgyz IP, Fast & Secure',
        meta_description: 'Browse safely with a reliable Kyrgyzstan VPN. Get a Kyrgyz IP address, access local content, and enjoy encrypted connections.'
      },
      NI: {
        meta_title: 'Nicaragua VPN - Fast & Secure Nicaraguan IP Access',
        meta_description: 'Get private, high-speed access with a secure Nicaragua VPN. Browse with a Nicaraguan IP, unblock content, and stay protected online.'
      },
      MV: {
        meta_title: 'Maldives VPN - Private Maldivian IP, Fast & Reliable',
        meta_description: 'Use a trusted Maldives VPN for secure, private browsing. Get a Maldivian IP address, access local content, and enjoy fast, encrypted access.'
      },
      NE: {
        meta_title: 'Niger VPN - Secure Nigerien IP, Fast & Private',
        meta_description: 'Browse securely with a reliable Niger VPN. Get a Nigerian IP address, unblock content, and protect your privacy online.'
      },
      MC: {
        meta_title: 'Monaco VPN - Fast & Private Monégasque IP Access',
        meta_description: 'Enjoy private browsing with a secure Monaco VPN. Get a Monégasque IP address, access local content, and stay protected with encrypted connections.'
      },
      PY: {
        meta_title: 'Paraguay VPN - Secure Paraguayan IP, Fast & Reliable',
        meta_description: 'Use a trusted Paraguay VPN for fast, secure browsing. Get a Paraguayan IP address, unblock content, and protect your privacy online.'
      },
      UY: {
        meta_title: 'Uruguay VPN - Private Uruguayan IP, Fast & Secure',
        meta_description: 'Browse safely with a reliable Uruguay VPN. Get a Uruguayan IP address, access local content, and enjoy encrypted connections.'
      },
      YE: {
        meta_title: 'Yemen VPN - Fast & Secure Yemeni IP Access',
        meta_description: 'Get private, high-speed access with a secure Yemen VPN. Browse with a Yemeni IP, unblock content, and stay protected online.'
      },
      ZM: {
        meta_title: 'Zambia VPN - Private Zambian IP, Fast & Reliable',
        meta_description: 'Use a trusted Zambia VPN for secure, private browsing. Get a Zambian IP address, access local content, and enjoy fast, encrypted access.'
      },
      SD: {
        meta_title: 'Sudan VPN - Secure Sudanese IP, Fast & Private',
        meta_description: 'Browse securely with a reliable Sudan VPN. Get a Sudanese IP address, unblock content, and protect your privacy online.'
      },
      PW: {
        meta_title: 'Palau VPN - Fast & Private Palauan IP Access',
        meta_description: 'Browse securely with a trusted Palau VPN. Get a Palauan IP address, access local content, and enjoy fast, private connections.'
      },
      BB: {
        meta_title: 'Barbados VPN - Secure Barbadian IP, Fast & Reliable',
        meta_description: 'Use a reliable Barbados VPN for private, secure browsing. Get a Barbadian IP address, unblock content, and protect your privacy online.'
      },
      BM: {
        meta_title: 'Bermuda VPN - Private Bermudian IP, Fast & Secure',
        meta_description: 'Stay protected online with a secure Bermuda VPN. Get a Bermudian IP address, access local content, and browse with encrypted connections.'
      },
      FJ: {
        meta_title: 'Fiji VPN - Fast & Secure Fijian IP Access',
        meta_description: 'Browse safely with a trusted Fiji VPN. Get a Fijian IP address, unblock content, and enjoy private, fast browsing.'
      },
      SC: {
        meta_title: 'Seychelles VPN - Private Seychellois IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Seychelles VPN. Browse with a Seychellois IP, access local content, and stay protected online.'
      },
      AO: {
        meta_title: 'Angola VPN - Secure Angolan IP, Fast & Private',
        meta_description: 'Use a trusted Angola VPN for secure, private browsing. Get an Angolan IP address, unblock content, and enjoy fast, encrypted access.'
      },
      LS: {
        meta_title: 'Lesotho VPN - Fast & Private Lesotho IP Access',
        meta_description: 'Browse securely with a reliable Lesotho VPN. Get a Lesotho IP address, access local content, and protect your privacy online.'
      },
      CM: {
        meta_title: 'Cameroon VPN - Secure Cameroonian IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Cameroon VPN. Get a Cameroonian IP address, unblock content, and stay protected with encrypted connections.'
      },
      MR: {
        meta_title: 'Mauritania VPN - Private Mauritanian IP, Fast & Secure',
        meta_description: 'Use a trusted Mauritania VPN for fast, secure browsing. Get a Mauritanian IP address, unblock content, and protect your privacy online.'
      },
      MZ: {
        meta_title: 'Mozambique VPN - Fast & Secure Mozambican IP Access',
        meta_description: 'Browse safely with a reliable Mozambique VPN. Get a Mozambican IP address, access local content, and enjoy encrypted connections.'
      },
      VA: {
        meta_title: 'Vatican City VPN - Private Vatican IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Vatican VPN. Browse with a Vatican IP, unblock content, and stay protected online.'
      },
      CF: {
        meta_title: 'Central African Republic VPN - Secure CAR IP, Fast & Private',
        meta_description: 'Use a trusted Central African Republic VPN for secure, private browsing. Get a Central African IP address, access local content, and enjoy fast, encrypted access.'
      },
      HT: {
        meta_title: 'Haiti VPN - Fast & Private Haitian IP Access',
        meta_description: 'Browse securely with a reliable Haiti VPN. Get a Haitian IP address, unblock content, and protect your privacy online.'
      },
      BW: {
        meta_title: 'Botswana VPN - Secure Botswanan IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Botswana VPN. Get a Botswanan IP address, access local content, and stay protected with encrypted connections.'
      },
      MG: {
        meta_title: 'Madagascar VPN - Private Malagasy IP, Fast & Secure',
        meta_description: 'Use a trusted Madagascar VPN for fast, secure browsing. Get a Malagasy IP address, unblock content, and protect your privacy online.'
      },
      SN: {
        meta_title: 'Senegal VPN - Fast & Secure Senegalese IP Access',
        meta_description: 'Browse safely with a reliable Senegal VPN. Get a Senegalese IP address, access local content, and enjoy encrypted connections.'
      },
      TJ: {
        meta_title: 'Tajikistan VPN - Private Tajik IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Tajikistan VPN. Browse with a Tajik IP, unblock content, and stay protected online.'
      },
      BZ: {
        meta_title: 'Belize VPN - Secure Belizean IP, Fast & Private',
        meta_description: 'Use a trusted Belize VPN for secure, private browsing. Get a Belizean IP address, access local content, and enjoy fast, encrypted access.'
      },
      GU: {
        meta_title: 'Guam VPN - Fast & Private Guamanian IP Access',
        meta_description: 'Browse securely with a reliable Guam VPN. Get a Guamanian IP address, unblock content, and protect your privacy online.'
      },
      BI: {
        meta_title: 'Burundi VPN - Secure Burundian IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Burundi VPN. Get a Burundian IP address, access local content, and stay protected with encrypted connections.'
      },
      CG: {
        meta_title: 'Congo VPN - Private Congolese IP, Fast & Secure',
        meta_description: 'Use a trusted Congo VPN for fast, secure browsing. Get a Congolese IP address, unblock content, and protect your privacy online.'
      },
      GQ: {
        meta_title: 'Equatorial Guinea VPN - Fast & Secure Equatoguinean IP',
        meta_description: 'Browse safely with a reliable Equatorial Guinea VPN. Get an Equatoguinean IP address, access local content, and enjoy encrypted connections.'
      },
      GI: {
        meta_title: 'Gibraltar VPN - Private Gibraltar IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Gibraltar VPN. Browse with a Gibraltarian IP, unblock content, and stay protected online.'
      },
      LI: {
        meta_title: 'Liechtenstein VPN - Secure Liechtenstein IP, Fast & Private',
        meta_description: 'Use a trusted Liechtenstein VPN for secure, private browsing. Get a Liechtenstein IP address, access local content, and enjoy fast, encrypted access.'
      },
      MW: {
        meta_title: 'Malawi VPN - Secure Malawian IP, Fast & Private',
        meta_description: 'Browse securely with a reliable Malawi VPN. Get a Malawian IP address, unblock content, and protect your privacy online.'
      },
      ML: {
        meta_title: 'Mali VPN - Fast & Private Malian IP Access',
        meta_description: 'Browse securely with a trusted Mali VPN. Get a Malian IP address, access local content, and enjoy fast, private connections.'
      },
      NA: {
        meta_title: 'Namibia VPN - Secure Namibian IP, Fast & Reliable',
        meta_description: 'Use a reliable Namibia VPN for private, secure browsing. Get a Namibian IP address, unblock content, and protect your privacy online.'
      },
      PG: {
        meta_title: 'Papua New Guinea VPN - Private PNG IP, Fast & Secure',
        meta_description: 'Stay protected online with a secure Papua New Guinea VPN. Get a PNG IP address, access local content, and browse with encrypted connections.'
      },
      RW: {
        meta_title: 'Rwanda VPN - Fast & Secure Rwandan IP Access',
        meta_description: 'Browse safely with a trusted Rwanda VPN. Get a Rwandan IP address, unblock content, and enjoy private, fast browsing.'
      },
      LC: {
        meta_title: 'Saint Lucia VPN - Private Saint Lucian IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Saint Lucia VPN. Browse with a Saint Lucian IP, access local content, and stay protected online.'
      },
      TG: {
        meta_title: 'Togo VPN - Secure Togolese IP, Fast & Private',
        meta_description: 'Use a trusted Togo VPN for secure, private browsing. Get a Togolese IP address, unblock content, and enjoy fast, encrypted access.'
      },
      TO: {
        meta_title: 'Tonga VPN - Fast & Private Tongan IP Access',
        meta_description: 'Browse securely with a reliable Tonga VPN. Get a Tongan IP address, access local content, and protect your privacy online.'
      },
      KY: {
        meta_title: 'Cayman Islands VPN - Secure Cayman IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Cayman Islands VPN. Get a Caymanian IP address, unblock content, and stay protected with encrypted connections.'
      },
      BJ: {
        meta_title: 'Benin VPN - Private Beninese IP, Fast & Secure',
        meta_description: 'Use a trusted Benin VPN for fast, secure browsing. Get a Beninese IP address, unblock content, and protect your privacy online.'
      },
      GN: {
        meta_title: 'Guinea VPN - Fast & Secure Guinean IP Access',
        meta_description: 'Browse safely with a reliable Guinea VPN. Get a Guinean IP address, access local content, and enjoy encrypted connections.'
      },
      NR: {
        meta_title: 'Nauru VPN - Private Nauruan IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Nauru VPN. Browse with a Nauruan IP, unblock content, and stay protected online.'
      },
      SM: {
        meta_title: 'San Marino VPN - Secure Sammarinese IP, Fast & Private',
        meta_description: 'Use a trusted San Marino VPN for secure, private browsing. Get a Sammarinese IP address, access local content, and enjoy fast, encrypted access.'
      },
      SL: {
        meta_title: 'Sierra Leone VPN - Fast & Private Sierra Leonean IP',
        meta_description: 'Browse securely with a reliable Sierra Leone VPN. Get a Sierra Leonean IP address, unblock content, and protect your privacy online.'
      },
      SR: {
        meta_title: 'Suriname VPN - Secure Surinamese IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Suriname VPN. Get a Surinamese IP address, access local content, and stay protected with encrypted connections.'
      },
      TT: {
        meta_title: 'Trinidad and Tobago VPN - Private Trinidadian IP, Fast & Secure',
        meta_description: 'Use a trusted Trinidad and Tobago VPN for fast, secure browsing. Get a Trinbagonian IP address, unblock content, and protect your privacy online.'
      },
      TV: {
        meta_title: 'Tuvalu VPN - Fast & Secure Tuvaluan IP Access',
        meta_description: 'Browse safely with a reliable Tuvalu VPN. Get a Tuvaluan IP address, access local content, and enjoy encrypted connections.'
      },
      AS: {
        meta_title: 'American Samoa VPN - Private Samoan IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure American Samoa VPN. Browse with an American Samoan IP, unblock content, and stay protected online.'
      },
      AI: {
        meta_title: 'Anguilla VPN - Secure Anguillan IP, Fast & Private',
        meta_description: 'Use a trusted Anguilla VPN for secure, private browsing. Get an Anguillan IP address, access local content, and enjoy fast, encrypted access.'
      },
      AG: {
        meta_title: 'Antigua and Barbuda VPN - Fast & Private Antiguan IP',
        meta_description: 'Browse securely with a reliable Antigua and Barbuda VPN. Get an Antiguan IP address, unblock content, and protect your privacy online.'
      },
      JE: {
        meta_title: 'Bailiwick of Jersey VPN - Secure Jersey IP, Fast & Reliable',
        meta_description: 'Enjoy private browsing with a secure Jersey VPN. Get a Jersey IP address, access local content, and stay protected with encrypted connections.'
      },
      BA: {
        meta_title: 'Bosnia and Herzegovina VPN - Private Bosnian IP, Fast & Secure',
        meta_description: 'Use a trusted Bosnia and Herzegovina VPN for fast, secure browsing. Get a Bosnian IP address, unblock content, and protect your privacy online.'
      },
      BF: {
        meta_title: 'Burkina Faso VPN - Fast & Secure Burkinabé IP Access',
        meta_description: 'Browse safely with a reliable Burkina Faso VPN. Get a Burkinabé IP address, access local content, and enjoy encrypted connections.'
      },
      CV: {
        meta_title: 'Cape Verde VPN - Private Cape Verdean IP, Fast & Reliable',
        meta_description: 'Get private, high-speed access with a secure Cape Verde VPN. Browse with a Cape Verdean IP, unblock content, and stay protected online.'
      },
      KM: {
        meta_title: 'Comoros VPN - Secure Comorian IP, Fast & Private',
        meta_description: 'Use a trusted Comoros VPN for secure, private browsing. Get a Comorian IP address, access local content, and enjoy fast, encrypted access.'
      },
      CK: {
        meta_title: 'Cook Islands VPN - Fast & Private Cook Islands IP',
        meta_description: 'Browse securely with a reliable Cook Islands VPN. Get a Cook Islands IP address, unblock content, and protect your privacy online.'
      },
      DJ: {
        meta_title: 'Djibouti VPN - Private Djiboutian IP, Fast & Secure',
        meta_description: 'Use a reliable Djibouti VPN for private, secure browsing. Get a Djiboutian IP address, unblock content, and protect your privacy online.'
      },
      ER: {
        meta_title: 'Eritrea VPN - Fast & Secure Eritrean IP Access',
        meta_description: 'Stay protected online with a secure Eritrea VPN. Get an Eritrean IP address, access local content, and browse with encrypted connections.'
      },
      FO: {
        meta_title: 'Faroe Islands VPN - Private Faroese IP, Fast & Reliable',
        meta_description: 'Browse safely with a trusted Faroe Islands VPN. Get a Faroese IP address, unblock content, and enjoy private, fast browsing.'
      },
      PF: {
        meta_title: 'French Polynesia VPN - Secure Tahitian IP, Fast & Private',
        meta_description: 'Get private, high-speed access with a secure French Polynesia VPN. Browse with a Polynesian IP, access local content, and stay protected online.'
      },
      GA: {
        meta_title: 'Gabon VPN - Fast & Private Gabonese IP Access',
        meta_description: 'Use a trusted Gabon VPN for secure, private browsing. Get a Gabonese IP address, unblock content, and enjoy fast, encrypted access.'
      },
      GM: {
        meta_title: 'Gambia VPN - Secure Gambian IP, Fast & Reliable',
        meta_description: 'Browse securely with a reliable Gambia VPN. Get a Gambian IP address, access local content, and protect your privacy online.'
      },
      GD: {
        meta_title: 'Grenada VPN - Private Grenadian IP, Fast & Secure',
        meta_description: 'Enjoy private browsing with a secure Grenada VPN. Get a Grenadian IP address, unblock content, and stay protected with encrypted connections.'
      },
      GG: {
        meta_title: 'Guernsey VPN - Fast & Secure Guernsey IP Access',
        meta_description: 'Use a trusted Guernsey VPN for fast, secure browsing. Get a Guernsey IP address, unblock content, and protect your privacy online.'
      },
      GW: {
        meta_title: 'Guinea-Bissau VPN - Private Bissau-Guinean IP, Fast & Reliable',
        meta_description: 'Browse safely with a reliable Guinea-Bissau VPN. Get a Bissau-Guinean IP address, access local content, and enjoy encrypted connections.'
      },
      LR: {
        meta_title: 'Liberia VPN - Secure Liberian IP, Fast & Private',
        meta_description: 'Get private, high-speed access with a secure Liberia VPN. Browse with a Liberian IP, unblock content, and stay protected online.'
      },
      MH: {
        meta_title: 'Marshall Islands VPN - Fast & Private Marshallese IP',
        meta_description: 'Use a trusted Marshall Islands VPN for secure, private browsing. Get a Marshallese IP address, access local content, and enjoy fast, encrypted access.'
      },
      MQ: {
        meta_title: 'Martinique VPN - Secure Martinican IP, Fast & Reliable',
        meta_description: 'Browse securely with a reliable Martinique VPN. Get a Martinican IP address, unblock content, and protect your privacy online.'
      },
      FM: {
        meta_title: 'Micronesia VPN - Private Micronesian IP, Fast & Secure',
        meta_description: 'Enjoy private browsing with a secure Micronesia VPN. Get a Micronesian IP address, access local content, and stay protected with encrypted connections.'
      },
      MS: {
        meta_title: 'Montserrat VPN - Fast & Secure Montserrat IP Access',
        meta_description: 'Use a trusted Montserrat VPN for fast, secure browsing. Get a Montserratian IP address, unblock content, and protect your privacy online.'
      },
      NC: {
        meta_title: 'New Caledonia VPN - Private New Caledonian IP, Fast & Reliable',
        meta_description: 'Browse safely with a reliable New Caledonia VPN. Get a New Caledonian IP address, access local content, and enjoy encrypted connections.'
      },
      KN: {
        meta_title: 'Saint Kitts and Nevis VPN - Secure Kittitian IP, Fast & Private',
        meta_description: 'Get private, high-speed access with a secure Saint Kitts and Nevis VPN. Browse with a Kittitian or Nevisian IP, unblock content, and stay protected online.'
      },
      VC: {
        meta_title: 'Saint Vincent and the Grenadines VPN - Fast Vincentian IP, Secure & Private',
        meta_description: 'Use a trusted Saint Vincent VPN for secure, private browsing. Get a Vincentian IP address, access local content, and enjoy fast, encrypted access.'
      },
      ST: {
        meta_title: 'São Tomé and Príncipe VPN - Private Santomean IP, Fast & Secure',
        meta_description: 'Browse securely with a reliable São Tomé and Príncipe VPN. Get a Santomean IP address, unblock content, and protect your privacy online.'
      },
      SK: {
        meta_title: 'Slovak Republic VPN - Fast & Secure Slovak IP Access',
        meta_description: 'Enjoy private browsing with a secure Slovakia VPN. Get a Slovak IP address, access local content, and stay protected with encrypted connections.'
      },
      SB: {
        meta_title: 'Solomon Islands VPN - Private Solomon IP, Fast & Reliable',
        meta_description: 'Use a trusted Solomon Islands VPN for fast, secure browsing. Get a Solomon Islander IP address, unblock content, and protect your privacy online.'
      },
      SZ: {
        meta_title: 'Swaziland VPN - Secure Swazi IP, Fast & Private',
        meta_description: 'Browse safely with a reliable Swaziland VPN. Get a Swazi IP address, access local content, and enjoy encrypted connections.'
      },
      TL: {
        meta_title: 'Timor-Leste VPN - Fast & Private Timorese IP Access',
        meta_description: 'Get private, high-speed access with a secure Timor-Leste VPN. Browse with an East Timorese IP, unblock content, and stay protected online.'
      },
      TC: {
        meta_title: 'Turks and Caicos Islands VPN - Secure TCI IP, Fast & Reliable',
        meta_description: 'Use a trusted Turks and Caicos VPN for secure, private browsing. Get a Turks and Caicos IP address, access local content, and enjoy fast, encrypted access.'
      },
      VU: {
        meta_title: 'Vanuatu VPN - Private Ni-Vanuatu IP, Fast & Secure',
        meta_description: 'Browse securely with a reliable Vanuatu VPN. Get a Ni-Vanuatu IP address, unblock content, and protect your privacy online.'
      },
      VG: {
        meta_title: 'British Virgin Islands VPN - Fast & Secure BVI IP Access',
        meta_description: 'Enjoy private browsing with a secure British Virgin Islands VPN. Get a BVI IP address, access local content, and stay protected with encrypted connections.'
      },
      VI: {
        meta_title: 'US Virgin Islands VPN - Private USVI IP, Fast & Reliable',
        meta_description: 'Use a trusted US Virgin Islands VPN for fast, secure browsing. Get a USVI IP address, unblock content, and protect your privacy online.'
      },
      EH: {
        meta_title: 'Western Sahara VPN - Secure Sahrawi IP, Fast & Private',
        meta_description: 'Browse safely with a reliable Western Sahara VPN. Get a Sahrawi IP address, access local content, and enjoy encrypted connections.'
      },
      WS: {
        meta_title: 'Western Samoa VPN - Fast & Private Samoan IP Access',
        meta_description: 'Get private, high-speed access with a secure Western Samoa VPN. Browse with a Samoan IP, unblock content, and stay protected online.'
      }
    };
    E.timezone = {
      CI: 'Africa/Abidjan',
      GH: 'Africa/Accra',
      ET: 'Africa/Addis_Ababa',
      DZ: 'Africa/Algiers',
      ER: 'Africa/Asmara',
      ML: 'Africa/Bamako',
      CF: 'Africa/Bangui',
      GM: 'Africa/Banjul',
      GW: 'Africa/Bissau',
      MW: 'Africa/Blantyre',
      CG: 'Africa/Brazzaville',
      BI: 'Africa/Bujumbura',
      EG: 'Africa/Cairo',
      MA: 'Africa/Casablanca',
      GN: 'Africa/Conakry',
      SN: 'Africa/Dakar',
      TZ: 'Africa/Dar_es_Salaam',
      DJ: 'Africa/Djibouti',
      CM: 'Africa/Douala',
      EH: 'Africa/El_Aaiun',
      SL: 'Africa/Freetown',
      BW: 'Africa/Gaborone',
      ZW: 'Africa/Harare',
      ZA: 'Africa/Johannesburg',
      SS: 'Africa/Juba',
      UG: 'Africa/Kampala',
      SD: 'Africa/Khartoum',
      RW: 'Africa/Kigali',
      CD: 'Africa/Kinshasa',
      NG: 'Africa/Lagos',
      GA: 'Africa/Libreville',
      TG: 'Africa/Lome',
      AO: 'Africa/Luanda',
      ZM: 'Africa/Lusaka',
      GQ: 'Africa/Malabo',
      MZ: 'Africa/Maputo',
      LS: 'Africa/Maseru',
      SZ: 'Africa/Mbabane',
      SO: 'Africa/Mogadishu',
      LR: 'Africa/Monrovia',
      KE: 'Africa/Nairobi',
      TD: 'Africa/Ndjamena',
      NE: 'Africa/Niamey',
      MR: 'Africa/Nouakchott',
      BF: 'Africa/Ouagadougou',
      BJ: 'Africa/Porto-Novo',
      ST: 'Africa/Sao_Tome',
      LY: 'Africa/Tripoli',
      TN: 'Africa/Tunis',
      NA: 'Africa/Windhoek',
      AI: 'America/Anguilla',
      AG: 'America/Antigua',
      AR: 'America/Argentina/Buenos_Aires',
      AW: 'America/Aruba',
      PY: 'America/Asuncion',
      BB: 'America/Barbados',
      BZ: 'America/Belize',
      CO: 'America/Bogota',
      VE: 'America/Caracas',
      KY: 'America/Cayman',
      CR: 'America/Costa_Rica',
      CW: 'America/Curacao',
      DM: 'America/Dominica',
      SV: 'America/El_Salvador',
      GL: 'America/Godthab',
      TC: 'America/Grand_Turk',
      GD: 'America/Grenada',
      GT: 'America/Guatemala',
      EC: 'America/Guayaquil',
      GY: 'America/Guyana',
      CU: 'America/Havana',
      JM: 'America/Jamaica',
      BO: 'America/La_Paz',
      PE: 'America/Lima',
      NI: 'America/Managua',
      MF: 'America/Marigot',
      MQ: 'America/Martinique',
      MX: 'America/Mexico_City',
      UY: 'America/Montevideo',
      MS: 'America/Montserrat',
      BS: 'America/Nassau',
      BR: 'America/Sao_Paulo',
      PA: 'America/Panama',
      SR: 'America/Paramaribo',
      HT: 'America/Port-au-Prince',
      TT: 'America/Port_of_Spain',
      PR: 'America/Puerto_Rico',
      CL: 'America/Santiago',
      DO: 'America/Santo_Domingo',
      BL: 'America/St_Barthelemy',
      KN: 'America/St_Kitts',
      LC: 'America/St_Lucia',
      VI: 'America/St_Thomas',
      VC: 'America/St_Vincent',
      HN: 'America/Tegucigalpa',
      VG: 'America/Tortola',
      AQ: 'Pacific/Auckland',
      YE: 'Asia/Aden',
      KZ: 'Asia/Almaty',
      JO: 'Asia/Amman',
      TM: 'Asia/Ashgabat',
      IQ: 'Asia/Baghdad',
      BH: 'Asia/Bahrain',
      AZ: 'Asia/Baku',
      TH: 'Asia/Bangkok',
      LB: 'Asia/Beirut',
      KG: 'Asia/Bishkek',
      BN: 'Asia/Brunei',
      IN: 'Asia/Colombo',
      LK: 'Asia/Colombo',
      SY: 'Asia/Damascus',
      BD: 'Asia/Dhaka',
      TL: 'Asia/Dili',
      AE: 'Asia/Dubai',
      TJ: 'Asia/Dushanbe',
      PS: 'Asia/Gaza',
      VN: 'Asia/Ho_Chi_Minh',
      HK: 'Asia/Hong_Kong',
      ID: 'Asia/Jakarta',
      AF: 'Asia/Kabul',
      PK: 'Asia/Karachi',
      NP: 'Asia/Kathmandu',
      MY: 'Asia/Kuala_Lumpur',
      KW: 'Asia/Kuwait',
      MO: 'Asia/Macau',
      PH: 'Asia/Manila',
      OM: 'Asia/Muscat',
      CY: 'Asia/Nicosia',
      KH: 'Asia/Phnom_Penh',
      KP: 'Asia/Pyongyang',
      QA: 'Asia/Qatar',
      MM: 'Asia/Rangoon',
      SA: 'Asia/Riyadh',
      KR: 'Asia/Seoul',
      CN: 'Asia/Shanghai',
      SG: 'Asia/Singapore',
      TW: 'Asia/Taipei',
      UZ: 'Asia/Tashkent',
      GE: 'Asia/Tbilisi',
      IR: 'Asia/Tehran',
      BT: 'Asia/Thimphu',
      JP: 'Asia/Tokyo',
      MN: 'Asia/Ulaanbaatar',
      LA: 'Asia/Vientiane',
      AM: 'Asia/Yerevan',
      BM: 'Atlantic/Bermuda',
      CV: 'Atlantic/Cape_Verde',
      FO: 'Atlantic/Faroe',
      IS: 'Atlantic/Reykjavik',
      GS: 'Atlantic/South_Georgia',
      SH: 'Atlantic/St_Helena',
      FK: 'Atlantic/Stanley',
      AU: 'Australia/Sydney',
      CA: 'America/Toronto',
      NL: 'Europe/Amsterdam',
      AD: 'Europe/Andorra',
      GR: 'Europe/Athens',
      RS: 'Europe/Belgrade',
      DE: 'Europe/Berlin',
      SK: 'Europe/Bratislava',
      BE: 'Europe/Brussels',
      RO: 'Europe/Bucharest',
      HU: 'Europe/Budapest',
      DK: 'Europe/Copenhagen',
      IE: 'Europe/Dublin',
      GI: 'Europe/Gibraltar',
      GG: 'Europe/Guernsey',
      FI: 'Europe/Helsinki',
      IM: 'Europe/Isle_of_Man',
      MD: 'Europe/Istanbul',
      TR: 'Europe/Istanbul',
      JE: 'Europe/Jersey',
      UA: 'Europe/Kiev',
      PT: 'Europe/Lisbon',
      SI: 'Europe/Ljubljana',
      GB: 'Europe/London',
      UK: 'Europe/London',
      LU: 'Europe/Luxembourg',
      ES: 'Europe/Madrid',
      MT: 'Europe/Malta',
      AX: 'Europe/Mariehamn',
      BY: 'Europe/Minsk',
      MC: 'Europe/Monaco',
      RU: 'Europe/Moscow',
      NO: 'Europe/Oslo',
      FR: 'Europe/Paris',
      ME: 'Europe/Podgorica',
      CZ: 'Europe/Prague',
      LV: 'Europe/Riga',
      IT: 'Europe/Rome',
      SM: 'Europe/San_Marino',
      BA: 'Europe/Sarajevo',
      MK: 'Europe/Skopje',
      BG: 'Europe/Sofia',
      SE: 'Europe/Stockholm',
      EE: 'Europe/Tallinn',
      AL: 'Europe/Tirane',
      LI: 'Europe/Vaduz',
      VA: 'Europe/Vatican',
      AT: 'Europe/Vienna',
      LT: 'Europe/Vilnius',
      HR: 'Europe/Zagreb',
      CH: 'Europe/Zurich',
      MG: 'Indian/Antananarivo',
      CX: 'Indian/Christmas',
      CC: 'Indian/Cocos',
      KM: 'Indian/Comoro',
      TF: 'Indian/Kerguelen',
      SC: 'Indian/Mahe',
      MV: 'Indian/Maldives',
      MU: 'Indian/Mauritius',
      YT: 'Indian/Mayotte',
      IL: 'Israel',
      WS: 'Pacific/Apia',
      NZ: 'Pacific/Auckland',
      FM: 'Pacific/Chuuk',
      VU: 'Pacific/Efate',
      TK: 'Pacific/Fakaofo',
      FJ: 'Pacific/Fiji',
      TV: 'Pacific/Funafuti',
      SB: 'Pacific/Guadalcanal',
      GU: 'Pacific/Guam',
      MH: 'Pacific/Majuro',
      NR: 'Pacific/Nauru',
      NU: 'Pacific/Niue',
      NF: 'Pacific/Norfolk',
      NC: 'Pacific/Noumea',
      AS: 'Pacific/Pago_Pago',
      PW: 'Pacific/Palau',
      PN: 'Pacific/Pitcairn',
      PG: 'Pacific/Port_Moresby',
      CK: 'Pacific/Rarotonga',
      MP: 'Pacific/Saipan',
      PF: 'Pacific/Tahiti',
      KI: 'Pacific/Tarawa',
      TO: 'Pacific/Tongatapu',
      WF: 'Pacific/Wallis',
      PL: 'Europe/Warsaw',
      US: 'America/New_York'
    };
    E.regions = {
      AD: ['Southern Europe', 'EMEA'],
      AE: ['Western Asia', 'EMEA'],
      AF: ['Southern Asia', 'EMEA'],
      AG: ['Caribbean', 'AMER'],
      AI: ['Caribbean', 'AMER'],
      AL: ['South-Eastern Europe', 'EMEA'],
      AM: ['Western Asia', 'EMEA'],
      AN: ['Caribbean'],
      AO: ['Middle Africa', 'EMEA'],
      AQ: ['Antarctica', 'APAC'],
      AR: ['South America', 'AMER'],
      AS: ['Polynesia', 'South America', 'AMER'],
      AT: ['Western Europe', 'EMEA'],
      AU: ['Australia and New Zealand', 'APAC'],
      AW: ['Caribbean', 'AMER'],
      AX: ['Scandinavia', 'EMEA', 'Northern Europe'],
      AZ: ['Western Asia', 'EMEA'],
      BA: ['South-Eastern Europe', 'EMEA'],
      BB: ['Caribbean', 'AMER'],
      BD: ['Southern Asia', 'APAC'],
      BE: ['Western Europe', 'EMEA'],
      GF: ['South America', 'AMER'],
      BF: ['Western Africa', 'EMEA'],
      BG: ['Eastern Europe', 'EMEA'],
      BH: ['Western Asia', 'EMEA'],
      BI: ['Eastern Africa', 'EMEA'],
      BJ: ['Western Africa', 'EMEA'],
      BL: ['Caribbean', 'AMER'],
      BM: ['Northern America', 'AMER'],
      BN: ['South-Eastern Asia', 'EMEA'],
      BO: ['South America', 'AMER'],
      BQ: ['Caribbean', 'AMER'],
      BR: ['South America', 'AMER'],
      BS: ['Caribbean', 'AMER'],
      BT: ['Southern Asia', 'APAC'],
      BW: ['Southern Africa', 'EMEA'],
      BY: ['Eastern Europe', 'EMEA'],
      BZ: ['South America', 'AMER'],
      CA: ['Northern America', 'AMER'],
      CC: ['Australia and New Zealand', 'APAC'],
      CD: ['Middle Africa', 'EMEA'],
      CF: ['Middle Africa', 'EMEA'],
      CG: ['Middle Africa', 'EMEA'],
      CH: ['Western Europe', 'EMEA'],
      CI: ['Western Africa', 'EMEA'],
      CK: ['Polynesia', 'APAC'],
      CL: ['South America', 'AMER'],
      CM: ['Middle Africa', 'EMEA'],
      CN: ['Asia', 'China'],
      CO: ['South America', 'AMER'],
      CR: ['South America', 'AMER'],
      CU: ['Caribbean', 'AMER'],
      CV: ['Western Africa', 'EMEA'],
      CW: ['Caribbean', ''],
      CX: ['Australia and New Zealand', 'APAC'],
      CY: ['South-Eastern Europe', 'EMEA'],
      CZ: ['Eastern Europe', 'EMEA'],
      DE: ['Western Europe', 'EMEA'],
      DJ: ['Eastern Africa', 'EMEA'],
      DK: ['Scandinavia', 'EMEA', 'Northern Europe'],
      DM: ['Caribbean', 'AMER'],
      DO: ['Caribbean', 'AMER'],
      DZ: ['Northern Africa', 'EMEA'],
      EC: ['South America', 'AMER'],
      EE: ['Eastern Europe', 'EMEA'],
      EG: ['Northern Africa', 'EMEA'],
      EH: ['Northern Africa', 'EMEA'],
      ER: ['Eastern Africa', 'EMEA'],
      ES: ['Southern Europe', 'EMEA'],
      ET: ['Eastern Africa', 'EMEA'],
      EU: ['Western Europe'],
      FI: ['Scandinavia', 'EMEA', 'Northern Europe'],
      FJ: ['Melanesia', 'APAC'],
      FK: ['South America', 'AMER'],
      FM: ['Micronesia', 'APAC'],
      FO: ['Scandinavia', 'EMEA', 'Northern Europe'],
      FR: ['Western Europe', 'EMEA'],
      GA: ['Middle Africa', 'EMEA'],
      GB: ['Northern Europe', 'EMEA'],
      GD: ['Caribbean', 'AMER'],
      GE: ['Western Asia', 'EMEA'],
      GG: ['Northern Europe', 'EMEA'],
      GH: ['Western Africa', 'EMEA'],
      GI: ['Southern Europe', 'EMEA'],
      GL: ['Scandinavia', 'EMEA', 'Northern Europe'],
      GM: ['Western Africa', 'EMEA'],
      GN: ['Western Africa', 'EMEA'],
      GP: ['Caribbean', 'AMER'],
      GQ: ['Middle Africa', 'EMEA'],
      GR: ['South-Eastern Europe', 'EMEA'],
      GS: ['Antarctica', 'South America', 'AMER'],
      GT: ['South America', 'AMER'],
      GU: ['Micronesia', 'APAC'],
      GW: ['Western Africa', 'EMEA'],
      GY: ['South America', 'EMEA'],
      HK: ['Eastern Asia', 'China'],
      HN: ['South America', 'AMER'],
      HR: ['South-Eastern Europe', 'EMEA'],
      HT: ['Caribbean', 'AMER'],
      HU: ['Eastern Europe', 'EMEA'],
      ID: ['South-Eastern Asia', 'APAC'],
      IE: ['Northern Europe', 'EMEA'],
      IL: ['Western Asia', 'EMEA'],
      IM: ['Northern Europe', 'EMEA'],
      IN: ['Southern Asia', 'APAC'],
      IQ: ['Western Asia', 'EMEA'],
      IR: ['Southern Asia', 'EMEA'],
      IS: ['Scandinavia', 'EMEA', 'Northern Europe'],
      IT: ['Southern Europe', 'EMEA'],
      JE: ['Northern Europe', 'EMEA'],
      JM: ['Caribbean', 'AMER'],
      JO: ['Western Asia', 'EMEA'],
      JP: ['Eastern Asia', 'APAC'],
      KE: ['Eastern Africa', 'EMEA'],
      KG: ['Central Asia', 'EMEA'],
      KH: ['South-Eastern Asia', 'APAC'],
      KI: ['Micronesia', 'EMEA'],
      KM: ['Eastern Africa', 'EMEA'],
      KN: ['Caribbean', 'AMER'],
      KP: ['Eastern Asia', 'APAC'],
      KR: ['Eastern Asia', 'APAC'],
      KW: ['Western Asia', 'EMEA'],
      KY: ['Caribbean', 'AMER'],
      KZ: ['Central Asia', 'EMEA'],
      LA: ['South-Eastern Asia', 'APAC'],
      LB: ['Western Asia', 'EMEA'],
      LC: ['Caribbean', 'AMER'],
      LI: ['Western Europe', 'EMEA'],
      LK: ['Southern Asia', 'APAC'],
      LR: ['Western Africa', 'EMEA'],
      LS: ['Southern Africa', 'EMEA'],
      LT: ['Eastern Europe', 'EMEA'],
      LU: ['Western Europe', 'EMEA'],
      LV: ['Eastern Europe', 'EMEA'],
      LY: ['Northern Africa', 'EMEA'],
      MA: ['Northern Africa', 'EMEA'],
      MC: ['Western Europe', 'EMEA'],
      MD: ['Eastern Europe', 'EMEA'],
      ME: ['South-Eastern Europe', 'EMEA'],
      MF: ['Caribbean', 'AMER'],
      MG: ['Eastern Africa', 'EMEA'],
      MH: ['Micronesia', 'AMER'],
      MK: ['South-Eastern Europe', 'EMEA'],
      ML: ['Western Africa', 'EMEA'],
      MM: ['South-Eastern Asia', 'APAC'],
      MN: ['Eastern Asia', 'APAC'],
      MO: ['Eastern Asia', 'APAC'],
      MP: ['Micronesia', 'AMER'],
      MQ: ['Caribbean', 'EMEA'],
      MR: ['Western Africa', 'EMEA'],
      MS: ['Caribbean', 'AMER'],
      MT: ['Southern Europe', 'EMEA'],
      MU: ['Eastern Africa', 'EMEA'],
      MV: ['Southern Asia', 'APAC'],
      MW: ['Eastern Africa', 'EMEA'],
      MX: ['South America', 'AMER'],
      MY: ['South-Eastern Asia', 'APAC'],
      MZ: ['Eastern Africa', 'EMEA'],
      NA: ['Southern Africa', 'EMEA'],
      NC: ['Melanesia', 'APAC'],
      NE: ['Western Africa', 'EMEA'],
      NF: ['Australia and New Zealand', 'AMER'],
      NG: ['Western Africa', 'EMEA'],
      NI: ['South America', 'AMER'],
      NL: ['Western Europe', 'EMEA'],
      NO: ['Scandinavia', 'EMEA', 'Northern Europe'],
      NP: ['Southern Asia', 'APAC'],
      NR: ['Micronesia', 'AMER'],
      NU: ['Polynesia', 'AMER'],
      NZ: ['Australia and New Zealand', 'APAC'],
      OM: ['Western Asia', 'EMEA'],
      PA: ['South America', 'AMER'],
      PE: ['South America', 'AMER'],
      PF: ['Polynesia', 'EMEA'],
      PG: ['Melanesia', 'APAC'],
      PH: ['South-Eastern Asia', 'APAC'],
      PK: ['Southern Asia', 'EMEA'],
      PL: ['Eastern Europe', 'EMEA'],
      PN: ['Polynesia', 'AMER'],
      PR: ['Caribbean', 'AMER'],
      PS: ['Western Asia', 'EMEA'],
      PT: ['Southern Europe', 'EMEA'],
      PW: ['Micronesia', 'APAC'],
      PY: ['South America', 'AMER'],
      QA: ['Western Asia', 'EMEA'],
      RE: ['Eastern Africa', 'EMEA'],
      RO: ['Eastern Europe', 'EMEA'],
      RS: ['South-Eastern Europe', 'EMEA'],
      RU: ['Eastern Europe', 'EMEA'],
      RW: ['Eastern Africa', 'EMEA'],
      SA: ['Western Asia', 'EMEA'],
      SB: ['Melanesia', 'APAC'],
      SC: ['Eastern Africa', 'APAC'],
      SD: ['Northern Africa', 'EMEA'],
      SE: ['Scandinavia', 'EMEA', 'Northern Europe'],
      SG: ['South-Eastern Asia', 'APAC'],
      SX: ['Caribbean', 'AMER'],
      SH: ['Western Africa', 'EMEA'],
      SI: ['South-Eastern Europe', 'EMEA'],
      SK: ['Eastern Europe', 'EMEA'],
      SL: ['Western Africa', 'EMEA'],
      SM: ['Southern Europe', 'EMEA'],
      SN: ['Western Africa', 'EMEA'],
      SO: ['Eastern Africa', 'EMEA'],
      SR: ['South America', 'AMER'],
      SS: ['Eastern Africa', 'EMEA'],
      ST: ['Middle Africa', 'EMEA'],
      SV: ['South America', 'AMER'],
      SY: ['Western Asia', 'EMEA'],
      SZ: ['Southern Africa', 'EMEA'],
      TC: ['Caribbean', 'AMER'],
      TD: ['Middle Africa', 'EMEA'],
      TF: ['Antarctica', 'EMEA'],
      TG: ['Western Africa', 'EMEA'],
      TH: ['South-Eastern Asia', 'APAC'],
      TJ: ['Central Asia', 'EMEA'],
      TK: ['Polynesia', 'EMEA'],
      TL: ['South-Eastern Asia', 'APAC'],
      TM: ['Central Asia', 'EMEA'],
      TN: ['Northern Africa', 'EMEA'],
      TO: ['Polynesia', 'APAC'],
      TR: ['South-Eastern Europe', 'EMEA'],
      TT: ['Caribbean', 'AMER'],
      TV: ['Polynesia', 'AMER'],
      TW: ['Eastern Asia', 'China'],
      TZ: ['Eastern Africa', 'EMEA'],
      UA: ['Eastern Europe', 'EMEA'],
      UG: ['Eastern Africa', 'EMEA'],
      UK: ['Northern Europe', 'EMEA'],
      US: ['Northern America', 'AMER'],
      UY: ['South America', 'AMER'],
      UZ: ['Central Asia', 'EMEA'],
      VA: ['Southern Europe', 'EMEA'],
      VC: ['Caribbean', 'AMER'],
      VE: ['South America', 'AMER'],
      VG: ['Caribbean', 'AMER'],
      VI: ['Caribbean', 'AMER'],
      VN: ['South-Eastern Asia', 'APAC'],
      VU: ['Melanesia', 'APAC'],
      WF: ['Polynesia', 'AMER'],
      WS: ['Polynesia', 'APAC'],
      XK: ['South-Eastern Europe', 'EMEA'],
      YE: ['Western Asia', 'EMEA'],
      YT: ['Eastern Africa', 'EMEA'],
      ZA: ['Southern Africa', 'EMEA'],
      ZM: ['Eastern Africa', 'EMEA'],
      ZW: ['Eastern Africa', 'EMEA']
    };
    var supraregions = {
      'Northern America': ['America'],
      'South America': ['LATAM'],
      'Central America': ['LATAM'],
      Caribbean: ['LATAM', 'South America'],
      LATAM: ['America'],
      'Eastern Europe': ['Eastern Europe (W/E)'],
      'South-Eastern Europe': ['Eastern Europe (W/E)'],
      'Western Europe': ['Western Europe (W/E)'],
      'Southern Europe': ['Western Europe (W/E)'],
      'Northern Europe': ['Western Europe (W/E)'],
      'Western Europe (W/E)': ['Europe'],
      'Eastern Europe (W/E)': ['Europe'],
      Polynesia: ['Oceania'],
      Melanesia: ['Oceania'],
      Micronesia: ['Oceania'],
      'Australia and New Zealand': ['Oceania'],
      Oceania: ['APAC'],
      'South-Eastern Asia': ['APAC', 'Asia'],
      'Southern Asia': ['APAC', 'Asia'],
      'Eastern Asia': ['APAC', 'Asia'],
      'Central Asia': ['Asia'],
      'Western Asia': ['Asia'],
      'Eastern Africa': ['Africa'],
      'Western Africa': ['Africa'],
      'Southern Africa': ['Africa'],
      'Northern Africa': ['Africa'],
      'Middle Africa': ['Africa']
    };
    var extend_regions = function extend_regions(regions) {
      for (var i = 0; i < regions.length; i++) {
        (supraregions[regions[i]] || []).filter(function (extra) {
          return !regions.includes(extra);
        }).forEach(function (extra) {
          regions.push(extra);
        });
      }
      regions.push('All');
    };
    (function () {
      for (var country in E.regions) extend_regions(E.regions[country]);
    })();
    E.unallowed_list = {
      SY: 1,
      LB: 1,
      IR: 1,
      IQ: 1,
      DO: 1
    };
    E.is_allowed = function (code) {
      return E.list[code] && !E.unallowed_list[code];
    };
    E.gdpr_countries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GF', 'GP', 'GR', 'HR', 'HU', 'IC', 'IE', 'IS', 'IT', 'JE', 'LI', 'LT', 'LU', 'LV', 'MF', 'MQ', 'MT', 'NL', 'NO', 'PL', 'PT', 'RE', 'RO', 'SI', 'SK', 'SW', 'YT', 'UK'];
    E.dialing_code_list = {
      AF: '93',
      AL: '355',
      DZ: '213',
      AX: '358',
      AS: '1684',
      AD: '376',
      AO: '244',
      AI: '1264',
      AQ: '672',
      AG: '1268',
      AR: '54',
      AM: '374',
      AW: '297',
      AU: '61',
      AT: '43',
      AZ: '994',
      BS: '1242',
      BH: '973',
      JE: '44',
      BD: '880',
      BB: '1246',
      BY: '375',
      BE: '32',
      BZ: '501',
      BJ: '229',
      BM: '1441',
      BT: '975',
      BO: '591',
      BA: '387',
      BW: '267',
      BR: '55',
      BN: '673',
      BG: '359',
      BF: '226',
      BI: '257',
      KH: '855',
      CM: '237',
      CV: '238',
      KY: '1345',
      CF: '236',
      TD: '235',
      CL: '56',
      CN: '86',
      CX: '61',
      CC: '61',
      CO: '57',
      KM: '269',
      CG: '242',
      CK: '682',
      CR: '506',
      CI: '225',
      HR: '385',
      CU: '53',
      CW: '599',
      CY: '357',
      CZ: '420',
      CD: '243',
      DK: '45',
      DJ: '253',
      DM: '1767',
      EC: '593',
      EG: '20',
      SV: '503',
      GQ: '240',
      ER: '291',
      EE: '372',
      ET: '251',
      FK: '500',
      FO: '298',
      FJ: '679',
      FI: '358',
      FR: '33',
      PF: '689',
      TF: '262',
      GA: '241',
      GM: '220',
      GE: '995',
      DE: '49',
      GH: '233',
      GI: '350',
      GB: '44',
      GR: '30',
      GL: '299',
      GD: '1473',
      GU: '1671',
      GT: '502',
      GG: '44',
      GN: '224',
      GW: '245',
      GY: '592',
      HT: '509',
      HN: '504',
      HK: '852',
      HU: '36',
      IS: '354',
      IN: '91',
      ID: '62',
      IR: '98',
      IQ: '964',
      IE: '353',
      IM: '44',
      IL: '972',
      IT: '39',
      JM: '1876',
      JP: '81',
      JO: '962',
      KE: '254',
      KI: '686',
      KW: '965',
      KG: '996',
      LA: '856',
      LV: '371',
      LB: '961',
      LS: '266',
      LR: '231',
      LY: '218',
      LI: '423',
      LT: '370',
      LU: '352',
      MO: '853',
      MK: '389',
      MG: '261',
      MW: '265',
      MY: '60',
      MV: '960',
      ML: '223',
      MT: '356',
      MH: '692',
      MQ: '596',
      MR: '222',
      MU: '230',
      YT: '262',
      MX: '52',
      FM: '691',
      MD: '373',
      MC: '377',
      MN: '976',
      ME: '382',
      MS: '1664',
      MA: '212',
      MZ: '258',
      MM: '95',
      NA: '264',
      NR: '674',
      NP: '977',
      NL: '31',
      AN: '599',
      NC: '687',
      NZ: '64',
      NI: '505',
      NE: '227',
      NG: '234',
      NU: '683',
      NF: '672',
      KP: '850',
      MP: '1670',
      NO: '47',
      OM: '968',
      PK: '92',
      PW: '680',
      PS: '970',
      PA: '507',
      PG: '675',
      PY: '595',
      PE: '51',
      PH: '63',
      PN: '64',
      PL: '48',
      PT: '351',
      QA: '974',
      RO: '40',
      RW: '250',
      BL: '590',
      SH: '290',
      KN: '1869',
      LC: '1758',
      MF: '590',
      VC: '1784',
      SM: '378',
      ST: '239',
      SA: '966',
      SN: '221',
      RS: '381',
      SC: '248',
      SL: '232',
      SG: '65',
      SK: '421',
      SI: '386',
      SB: '677',
      SO: '252',
      ZA: '27',
      GS: '500',
      KR: '82',
      SS: '211',
      ES: '34',
      LK: '94',
      SD: '249',
      SR: '597',
      SZ: '268',
      SE: '46',
      CH: '41',
      SY: '963',
      TW: '886',
      TJ: '992',
      TZ: '255',
      TH: '66',
      TL: '670',
      TG: '228',
      TK: '690',
      TO: '676',
      TT: '1868',
      TN: '216',
      TR: '90',
      TM: '993',
      TC: '1649',
      TV: '688',
      UG: '256',
      UA: '380',
      AE: '971',
      UK: '44',
      UY: '598',
      UZ: '998',
      VU: '678',
      VA: '39',
      VE: '58',
      VN: '84',
      VG: '1284',
      VI: '1340',
      WF: '681',
      EH: '212',
      WS: '685',
      YE: '967',
      ZM: '260',
      ZW: '263',
      DO: '1',
      CA: '1',
      KZ: '7',
      US: '1',
      PR: '1',
      RU: '7'
    };
    E.dialing_code_rlist = {
      1: 'US',
      1403: 'CA',
      1587: 'CA',
      1780: 'CA',
      1825: 'CA',
      // Alberta
      1236: 'CA',
      1250: 'CA',
      1604: 'CA',
      1778: 'CA',
      // British Columbia
      1204: 'CA',
      1431: 'CA',
      // Manitoba
      1506: 'CA',
      // New Brunswick
      1709: 'CA',
      // Newfoundland and Labrador
      1902: 'CA',
      1782: 'CA',
      // Nova Scotia and Prince Edward Island
      1226: 'CA',
      1249: 'CA',
      1289: 'CA',
      1343: 'CA',
      1365: 'CA',
      1416: 'CA',
      1437: 'CA',
      1519: 'CA',
      1548: 'CA',
      1613: 'CA',
      1647: 'CA',
      1705: 'CA',
      1807: 'CA',
      1905: 'CA',
      // Ontario
      1418: 'CA',
      1438: 'CA',
      1450: 'CA',
      1514: 'CA',
      1579: 'CA',
      1581: 'CA',
      1819: 'CA',
      1873: 'CA',
      // Quebec
      1306: 'CA',
      1639: 'CA',
      // Saskatchewan
      1867: 'CA',
      // Yukon, Northwest Territories and Nunavut
      1787: 'PR',
      1939: 'PR',
      1809: 'DO',
      1829: 'DO',
      1849: 'DO',
      1242: 'BS',
      1246: 'BB',
      1264: 'AI',
      1268: 'AG',
      1284: 'VG',
      1340: 'VI',
      1345: 'KY',
      1441: 'BM',
      1473: 'GD',
      1649: 'TC',
      1664: 'MS',
      1670: 'MP',
      1671: 'GU',
      1684: 'AS',
      1758: 'LC',
      1767: 'DM',
      1784: 'VC',
      1868: 'TT',
      1869: 'KN',
      1876: 'JM',
      20: 'EG',
      211: 'SS',
      212: 'MA',
      212528: 'EH',
      213: 'DZ',
      216: 'TN',
      218: 'LY',
      220: 'GM',
      221: 'SN',
      222: 'MR',
      223: 'ML',
      224: 'GN',
      225: 'CI',
      226: 'BF',
      227: 'NE',
      228: 'TG',
      229: 'BJ',
      230: 'MU',
      231: 'LR',
      232: 'SL',
      233: 'GH',
      234: 'NG',
      235: 'TD',
      236: 'CF',
      237: 'CM',
      238: 'CV',
      239: 'ST',
      240: 'GQ',
      241: 'GA',
      242: 'CG',
      243: 'CD',
      244: 'AO',
      245: 'GW',
      248: 'SC',
      249: 'SD',
      250: 'RW',
      251: 'ET',
      252: 'SO',
      253: 'DJ',
      254: 'KE',
      255: 'TZ',
      256: 'UG',
      257: 'BI',
      258: 'MZ',
      260: 'ZM',
      261: 'MG',
      262: 'TF',
      262269: 'YT',
      262639: 'YT',
      263: 'ZW',
      264: 'NA',
      265: 'MW',
      266: 'LS',
      267: 'BW',
      268: 'SZ',
      269: 'KM',
      27: 'ZA',
      290: 'SH',
      291: 'ER',
      297: 'AW',
      298: 'FO',
      299: 'GL',
      30: 'GR',
      31: 'NL',
      32: 'BE',
      33: 'FR',
      34: 'ES',
      350: 'GI',
      351: 'PT',
      352: 'LU',
      353: 'IE',
      354: 'IS',
      355: 'AL',
      356: 'MT',
      357: 'CY',
      358: 'FI',
      35818: 'AX',
      358457: 'AX',
      359: 'BG',
      36: 'HU',
      370: 'LT',
      371: 'LV',
      372: 'EE',
      373: 'MD',
      374: 'AM',
      375: 'BY',
      376: 'AD',
      377: 'MC',
      378: 'SM',
      380: 'UA',
      381: 'RS',
      382: 'ME',
      385: 'HR',
      386: 'SI',
      387: 'BA',
      389: 'MK',
      39: 'IT',
      39066987: 'VA',
      39066988: 'VA',
      40: 'RO',
      41: 'CH',
      420: 'CZ',
      421: 'SK',
      423: 'LI',
      43: 'AT',
      44: 'GB',
      441481: 'GG',
      441534: 'JE',
      441624: 'IM',
      45: 'DK',
      46: 'SE',
      47: 'NO',
      48: 'PL',
      49: 'DE',
      500: 'FK',
      501: 'BZ',
      502: 'GT',
      503: 'SV',
      504: 'HN',
      505: 'NI',
      506: 'CR',
      507: 'PA',
      509: 'HT',
      51: 'PE',
      52: 'MX',
      53: 'CU',
      54: 'AR',
      55: 'BR',
      56: 'CL',
      57: 'CO',
      58: 'VE',
      590: 'BL',
      591: 'BO',
      592: 'GY',
      593: 'EC',
      595: 'PY',
      596: 'MQ',
      597: 'SR',
      598: 'UY',
      599: 'AN',
      60: 'MY',
      61: 'AU',
      619162: 'CC',
      619164: 'CX',
      62: 'ID',
      63: 'PH',
      64: 'NZ',
      65: 'SG',
      66: 'TH',
      670: 'TL',
      6721: 'AQ',
      67232: 'NF',
      67235: 'NF',
      673: 'BN',
      674: 'NR',
      675: 'PG',
      676: 'TO',
      677: 'SB',
      678: 'VU',
      679: 'FJ',
      680: 'PW',
      681: 'WF',
      682: 'CK',
      683: 'NU',
      685: 'WS',
      686: 'KI',
      687: 'NC',
      688: 'TV',
      689: 'PF',
      690: 'TK',
      691: 'FM',
      692: 'MH',
      7: 'RU',
      76: 'KZ',
      77: 'KZ',
      81: 'JP',
      82: 'KR',
      84: 'VN',
      850: 'KP',
      852: 'HK',
      853: 'MO',
      855: 'KH',
      856: 'LA',
      86: 'CN',
      880: 'BD',
      886: 'TW',
      90: 'TR',
      91: 'IN',
      92: 'PK',
      93: 'AF',
      94: 'LK',
      95: 'MM',
      960: 'MV',
      961: 'LB',
      962: 'JO',
      963: 'SY',
      964: 'IQ',
      965: 'KW',
      966: 'SA',
      967: 'YE',
      968: 'OM',
      970: 'PS',
      971: 'AE',
      972: 'IL',
      973: 'BH',
      974: 'QA',
      975: 'BT',
      976: 'MN',
      977: 'NP',
      98: 'IR',
      992: 'TJ',
      993: 'TM',
      994: 'AZ',
      995: 'GE',
      996: 'KG',
      998: 'UZ'
    };

    // https://developers.google.com/adwords/api/docs/appendix/geotargeting
    E.google_list = {
      AD: 'Andorra',
      AE: 'United Arab Emirates',
      AF: 'Afghanistan',
      AG: 'Antigua and Barbuda',
      AL: 'Albania',
      AM: 'Armenia',
      AO: 'Angola',
      AQ: 'Antarctica',
      AR: 'Argentina',
      AS: 'American Samoa',
      AT: 'Austria',
      AU: 'Australia',
      AZ: 'Azerbaijan',
      BA: 'Bosnia and Herzegovina',
      BB: 'Barbados',
      BD: 'Bangladesh',
      BE: 'Belgium',
      BF: 'Burkina Faso',
      BG: 'Bulgaria',
      BH: 'Bahrain',
      BI: 'Burundi',
      BJ: 'Benin',
      BN: 'Brunei',
      BO: 'Bolivia',
      BQ: 'Caribbean Netherlands',
      BR: 'Brazil',
      BS: 'The Bahamas',
      BT: 'Bhutan',
      BW: 'Botswana',
      BY: 'Belarus',
      BZ: 'Belize',
      CA: 'Canada',
      CC: 'Cocos (Keeling) Islands',
      CD: 'Democratic Republic of the Congo',
      CF: 'Central African Republic',
      CG: 'Republic of the Congo',
      CH: 'Switzerland',
      CI: 'Cote d\'Ivoire',
      CK: 'Cook Islands',
      CL: 'Chile',
      CM: 'Cameroon',
      CN: 'China',
      CO: 'Colombia',
      CR: 'Costa Rica',
      CV: 'Cape Verde',
      CW: 'Curacao',
      CX: 'Christmas Island',
      CY: 'Cyprus',
      CZ: 'Czechia',
      DE: 'Germany',
      DJ: 'Djibouti',
      DK: 'Denmark',
      DM: 'Dominica',
      DO: 'Dominican Republic',
      DZ: 'Algeria',
      EC: 'Ecuador',
      EE: 'Estonia',
      EG: 'Egypt',
      ER: 'Eritrea',
      ES: 'Spain',
      ET: 'Ethiopia',
      FI: 'Finland',
      FJ: 'Fiji',
      FM: 'Federated States of Micronesia',
      FR: 'France',
      GA: 'Gabon',
      GB: 'United Kingdom',
      GD: 'Grenada',
      GE: 'Georgia',
      GG: 'Guernsey',
      GH: 'Ghana',
      GM: 'The Gambia',
      GN: 'Guinea',
      GQ: 'Equatorial Guinea',
      GR: 'Greece',
      GS: 'South Georgia and the South Sandwich Islands',
      GT: 'Guatemala',
      GU: 'Guam',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HM: 'Heard Island and McDonald Islands',
      HN: 'Honduras',
      HR: 'Croatia',
      HT: 'Haiti',
      HU: 'Hungary',
      ID: 'Indonesia',
      IE: 'Ireland',
      IL: 'Israel',
      IN: 'India',
      IQ: 'Iraq',
      IS: 'Iceland',
      IT: 'Italy',
      JE: 'Jersey',
      JM: 'Jamaica',
      JO: 'Jordan',
      JP: 'Japan',
      KE: 'Kenya',
      KG: 'Kyrgyzstan',
      KH: 'Cambodia',
      KI: 'Kiribati',
      KM: 'Comoros',
      KN: 'Saint Kitts and Nevis',
      KR: 'South Korea',
      KW: 'Kuwait',
      KZ: 'Kazakhstan',
      LA: 'Laos',
      LB: 'Lebanon',
      LC: 'Saint Lucia',
      LI: 'Liechtenstein',
      LK: 'Sri Lanka',
      LR: 'Liberia',
      LS: 'Lesotho',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      LV: 'Latvia',
      LY: 'Libya',
      MA: 'Morocco',
      MC: 'Monaco',
      MD: 'Moldova',
      ME: 'Montenegro',
      MG: 'Madagascar',
      MH: 'Marshall Islands',
      MK: 'North Macedonia',
      ML: 'Mali',
      MM: 'Myanmar (Burma)',
      MN: 'Mongolia',
      MP: 'Northern Mariana Islands',
      MR: 'Mauritania',
      MT: 'Malta',
      MU: 'Mauritius',
      MV: 'Maldives',
      MW: 'Malawi',
      MX: 'Mexico',
      MY: 'Malaysia',
      MZ: 'Mozambique',
      NA: 'Namibia',
      NC: 'New Caledonia',
      NE: 'Niger',
      NF: 'Norfolk Island',
      NG: 'Nigeria',
      NI: 'Nicaragua',
      NL: 'Netherlands',
      NO: 'Norway',
      NP: 'Nepal',
      NR: 'Nauru',
      NU: 'Niue',
      NZ: 'New Zealand',
      OM: 'Oman',
      PA: 'Panama',
      PE: 'Peru',
      PF: 'French Polynesia',
      PG: 'Papua New Guinea',
      PH: 'Philippines',
      PK: 'Pakistan',
      PL: 'Poland',
      PM: 'Saint Pierre and Miquelon',
      PN: 'Pitcairn Islands',
      PT: 'Portugal',
      PW: 'Palau',
      PY: 'Paraguay',
      QA: 'Qatar',
      RO: 'Romania',
      RS: 'Serbia',
      RU: 'Russia',
      RW: 'Rwanda',
      SA: 'Saudi Arabia',
      SB: 'Solomon Islands',
      SC: 'Seychelles',
      SE: 'Sweden',
      SG: 'Singapore',
      SH: 'Saint Helena, Ascension and Tristan da Cunha',
      SI: 'Slovenia',
      SK: 'Slovakia',
      SL: 'Sierra Leone',
      SM: 'San Marino',
      SN: 'Senegal',
      SO: 'Somalia',
      SR: 'Suriname',
      ST: 'Sao Tome and Principe',
      SV: 'El Salvador',
      SX: 'Sint Maarten',
      SZ: 'Eswatini',
      TD: 'Chad',
      TF: 'French Southern and Antarctic Lands',
      TG: 'Togo',
      TH: 'Thailand',
      TJ: 'Tajikistan',
      TK: 'Tokelau',
      TL: 'Timor-Leste',
      TM: 'Turkmenistan',
      TN: 'Tunisia',
      TO: 'Tonga',
      TR: 'Turkey',
      TT: 'Trinidad and Tobago',
      TV: 'Tuvalu',
      TZ: 'Tanzania',
      UA: 'Ukraine',
      UG: 'Uganda',
      UM: 'United States Minor Outlying Islands',
      US: 'United States',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VA: 'Vatican City',
      VC: 'Saint Vincent and the Grenadines',
      VE: 'Venezuela',
      VN: 'Vietnam',
      VU: 'Vanuatu',
      WF: 'Wallis and Futuna',
      WS: 'Samoa',
      YE: 'Yemen',
      ZA: 'South Africa',
      ZM: 'Zambia',
      ZW: 'Zimbabwe'
    };
    E.lang_list = {
      en: 'English',
      ru: 'Russian',
      es: 'Spanish',
      tr: 'Turkish',
      de: 'German',
      ja: 'Japanese',
      fr: 'French',
      he: 'Hebrew',
      zh: 'Mandarin',
      pt: 'Portuguese'
    };
    E.us_state_zip_list = [{
      min: 35000,
      max: 36999,
      code: 'AL',
      name: 'Alabama'
    }, {
      min: 99500,
      max: 99999,
      code: 'AK',
      name: 'Alaska'
    }, {
      min: 85000,
      max: 86999,
      code: 'AZ',
      name: 'Arizona'
    }, {
      min: 71600,
      max: 72999,
      code: 'AR',
      name: 'Arkansas'
    }, {
      min: 90000,
      max: 96699,
      code: 'CA',
      name: 'California'
    }, {
      min: 80000,
      max: 81999,
      code: 'CO',
      name: 'Colorado'
    }, {
      min: 6000,
      max: 6999,
      code: 'CT',
      name: 'Connecticut'
    }, {
      min: 19700,
      max: 19999,
      code: 'DE',
      name: 'Deleware'
    }, {
      min: 32000,
      max: 34999,
      code: 'FL',
      name: 'Florida'
    }, {
      min: 30000,
      max: 31999,
      code: 'GA',
      name: 'Georgia'
    }, {
      min: 96700,
      max: 96999,
      code: 'HI',
      name: 'Hawaii'
    }, {
      min: 83200,
      max: 83999,
      code: 'ID',
      name: 'Idaho'
    }, {
      min: 60000,
      max: 62999,
      code: 'IL',
      name: 'Illinois'
    }, {
      min: 46000,
      max: 47999,
      code: 'IN',
      name: 'Indiana'
    }, {
      min: 50000,
      max: 52999,
      code: 'IA',
      name: 'Iowa'
    }, {
      min: 66000,
      max: 67999,
      code: 'KS',
      name: 'Kansas'
    }, {
      min: 40000,
      max: 42999,
      code: 'KY',
      name: 'Kentucky'
    }, {
      min: 70000,
      max: 71599,
      code: 'LA',
      name: 'Louisiana'
    }, {
      min: 3900,
      max: 4999,
      code: 'ME',
      name: 'Maine'
    }, {
      min: 20600,
      max: 21999,
      code: 'MD',
      name: 'Maryland'
    }, {
      min: 1000,
      max: 2799,
      code: 'MA',
      name: 'Massachusetts'
    }, {
      min: 48000,
      max: 49999,
      code: 'MI',
      name: 'Michigan'
    }, {
      min: 55000,
      max: 56999,
      code: 'MN',
      name: 'Minnesota'
    }, {
      min: 38600,
      max: 39999,
      code: 'MS',
      name: 'Mississippi'
    }, {
      min: 63000,
      max: 65999,
      code: 'MO',
      name: 'Missouri'
    }, {
      min: 59000,
      max: 59999,
      code: 'MT',
      name: 'Montana'
    }, {
      min: 27000,
      max: 28999,
      code: 'NC',
      name: 'North Carolina'
    }, {
      min: 58000,
      max: 58999,
      code: 'ND',
      name: 'North Dakota'
    }, {
      min: 68000,
      max: 69999,
      code: 'NE',
      name: 'Nebraska'
    }, {
      min: 88900,
      max: 89999,
      code: 'NV',
      name: 'Nevada'
    }, {
      min: 3000,
      max: 3899,
      code: 'NH',
      name: 'New Hampshire'
    }, {
      min: 7000,
      max: 8999,
      code: 'NJ',
      name: 'New Jersey'
    }, {
      min: 87000,
      max: 88499,
      code: 'NM',
      name: 'New Mexico'
    }, {
      min: 10000,
      max: 14999,
      code: 'NY',
      name: 'New York'
    }, {
      min: 43000,
      max: 45999,
      code: 'OH',
      name: 'Ohio'
    }, {
      min: 73000,
      max: 74999,
      code: 'OK',
      name: 'Oklahoma'
    }, {
      min: 97000,
      max: 97999,
      code: 'OR',
      name: 'Oregon'
    }, {
      min: 15000,
      max: 19699,
      code: 'PA',
      name: 'Pennsylvania'
    }, {
      min: 300,
      max: 999,
      code: 'PR',
      name: 'Puerto Rico'
    }, {
      min: 2800,
      max: 2999,
      code: 'RI',
      name: 'Rhode Island'
    }, {
      min: 29000,
      max: 29999,
      code: 'SC',
      name: 'South Carolina'
    }, {
      min: 57000,
      max: 57999,
      code: 'SD',
      name: 'South Dakota'
    }, {
      min: 37000,
      max: 38599,
      code: 'TN',
      name: 'Tennessee'
    }, {
      min: 75000,
      max: 79999,
      code: 'TX',
      name: 'Texas'
    }, {
      min: 88500,
      max: 88599,
      code: 'TX',
      name: 'Texas'
    }, {
      min: 84000,
      max: 84999,
      code: 'UT',
      name: 'Utah'
    }, {
      min: 5000,
      max: 5999,
      code: 'VT',
      name: 'Vermont'
    }, {
      min: 22000,
      max: 24699,
      code: 'VA',
      name: 'Virgina'
    }, {
      min: 20000,
      max: 20599,
      code: 'DC',
      name: 'Washington DC'
    }, {
      min: 98000,
      max: 99499,
      code: 'WA',
      name: 'Washington'
    }, {
      min: 24700,
      max: 26999,
      code: 'WV',
      name: 'West Virginia'
    }, {
      min: 53000,
      max: 54999,
      code: 'WI',
      name: 'Wisconsin'
    }, {
      min: 82000,
      max: 83199,
      code: 'WY',
      name: 'Wyoming'
    }];
    E.in_state_list = {
      AN: 'Andaman and Nicobar Islands',
      AP: 'Andhra Pradesh',
      AR: 'Arunachal Pradesh',
      AS: 'Assam',
      BR: 'Bihar',
      CG: 'Chandigarh',
      CH: 'Chhattisgarh',
      DN: 'Dadra and Nagar Haveli',
      DD: 'Daman and Diu',
      DL: 'Delhi',
      GA: 'Goa',
      GJ: 'Gujarat',
      HR: 'Haryana',
      HP: 'Himachal Pradesh',
      JK: 'Jammu and Kashmir',
      JH: 'Jharkhand',
      KA: 'Karnataka',
      KL: 'Kerala',
      LA: 'Ladakh',
      LD: 'Lakshadweep',
      MP: 'Madhya Pradesh',
      MH: 'Maharashtra',
      MN: 'Manipur',
      ML: 'Meghalaya',
      MZ: 'Mizoram',
      NL: 'Nagaland',
      OR: 'Odisha',
      PY: 'Puducherry',
      PB: 'Punjab',
      RJ: 'Rajasthan',
      SK: 'Sikkim',
      TN: 'Tamil Nadu',
      TS: 'Telangana',
      TR: 'Tripura',
      UP: 'Uttar Pradesh',
      UK: 'Uttarakhand',
      WB: 'West Bengal'
    };
    E.get_state_by_zip = function (zip) {
      zip = parseInt('' + zip, 10);
      var state = E.us_state_zip_list.filter(function (s) {
        return s.min <= zip && zip <= s.max;
      });
      if (state.length) return state[0].code;
    };
    E.currency_list = {
      AF: 'AFN',
      AL: 'ALL',
      DZ: 'DZD',
      AS: 'USD',
      AD: 'EUR',
      AO: 'AOA',
      AI: 'XCD',
      AG: 'XCD',
      AR: 'ARS',
      AM: 'AMD',
      AW: 'AWG',
      AU: 'AUD',
      AT: 'EUR',
      AZ: 'AZN',
      BS: 'BSD',
      BH: 'BHD',
      BD: 'BDT',
      BB: 'BBD',
      BY: 'BYN',
      BE: 'EUR',
      BZ: 'BZD',
      BJ: 'XOF',
      BM: 'BMD',
      BT: 'BTN',
      BO: 'BOB',
      BQ: 'USD',
      BA: 'BAM',
      BW: 'BWP',
      BV: 'NOK',
      BR: 'BRL',
      IO: 'USD',
      BN: 'BND',
      BG: 'BGN',
      BF: 'XOF',
      BI: 'BIF',
      CV: 'CVE',
      KH: 'KHR',
      CM: 'XAF',
      CA: 'CAD',
      KY: 'KYD',
      CF: 'XAF',
      TD: 'XAF',
      CL: 'CLF',
      CN: 'CNY',
      CX: 'AUD',
      CC: 'AUD',
      CO: 'COP',
      KM: 'KMF',
      CD: 'CDF',
      CG: 'XAF',
      CK: 'NZD',
      CR: 'CRC',
      HR: 'EUR',
      CU: 'CUC',
      CW: 'ANG',
      CY: 'EUR',
      CZ: 'CZK',
      CI: 'XOF',
      DK: 'DKK',
      DJ: 'DJF',
      DM: 'XCD',
      DO: 'DOP',
      EC: 'USD',
      EG: 'EGP',
      SV: 'SVC',
      GQ: 'XAF',
      ER: 'ERN',
      EE: 'EUR',
      ET: 'ETB',
      FK: 'FKP',
      FO: 'DKK',
      FJ: 'FJD',
      FI: 'EUR',
      FR: 'EUR',
      GF: 'EUR',
      PF: 'XPF',
      TF: 'EUR',
      GA: 'XAF',
      GM: 'GMD',
      GE: 'GEL',
      DE: 'EUR',
      GH: 'GHS',
      GI: 'GIP',
      GR: 'EUR',
      GL: 'DKK',
      GD: 'XCD',
      GP: 'EUR',
      GU: 'USD',
      GT: 'GTQ',
      GG: 'GBP',
      GN: 'GNF',
      GW: 'XOF',
      GY: 'GYD',
      HT: 'HTG',
      HM: 'AUD',
      VA: 'EUR',
      HN: 'HNL',
      HK: 'HKD',
      HU: 'HUF',
      IS: 'ISK',
      IN: 'INR',
      ID: 'IDR',
      IR: 'IRR',
      IQ: 'IQD',
      IE: 'EUR',
      IM: 'GBP',
      IL: 'ILS',
      IT: 'EUR',
      JM: 'JMD',
      JP: 'JPY',
      JE: 'GBP',
      JO: 'JOD',
      KZ: 'KZT',
      KE: 'KES',
      KI: 'AUD',
      KP: 'KPW',
      KR: 'KRW',
      KW: 'KWD',
      KG: 'KGS',
      LA: 'LAK',
      LV: 'EUR',
      LB: 'LBP',
      LS: 'LSL',
      LR: 'LRD',
      LY: 'LYD',
      LI: 'CHF',
      LT: 'EUR',
      LU: 'EUR',
      MO: 'MOP',
      MG: 'MGA',
      MW: 'MWK',
      MY: 'MYR',
      MV: 'MVR',
      ML: 'XOF',
      MT: 'EUR',
      MH: 'USD',
      MQ: 'EUR',
      MR: 'MRU',
      MU: 'MUR',
      YT: 'EUR',
      MX: 'MXN',
      FM: 'USD',
      MD: 'MDL',
      MC: 'EUR',
      MN: 'MNT',
      ME: 'EUR',
      MS: 'XCD',
      MA: 'MAD',
      MZ: 'MZN',
      MM: 'MMK',
      NA: 'NAD',
      NR: 'AUD',
      NP: 'NPR',
      NL: 'EUR',
      NC: 'XPF',
      NZ: 'NZD',
      NI: 'NIO',
      NE: 'XOF',
      NG: 'NGN',
      NU: 'NZD',
      NF: 'AUD',
      MP: 'USD',
      NO: 'NOK',
      OM: 'OMR',
      PK: 'PKR',
      PW: 'USD',
      PA: 'PAB',
      PG: 'PGK',
      PY: 'PYG',
      PE: 'PEN',
      PH: 'PHP',
      PN: 'NZD',
      PL: 'PLN',
      PT: 'EUR',
      PR: 'USD',
      QA: 'QAR',
      MK: 'MKD',
      RO: 'RON',
      RU: 'RUB',
      RW: 'RWF',
      RE: 'EUR',
      BL: 'EUR',
      SH: 'SHP',
      KN: 'XCD',
      LC: 'XCD',
      MF: 'EUR',
      PM: 'EUR',
      VC: 'XCD',
      WS: 'WST',
      SM: 'EUR',
      ST: 'STN',
      SA: 'SAR',
      SN: 'XOF',
      RS: 'RSD',
      SC: 'SCR',
      SL: 'SLL',
      SG: 'SGD',
      SX: 'ANG',
      SK: 'EUR',
      SI: 'EUR',
      SB: 'SBD',
      SO: 'SOS',
      ZA: 'ZAR',
      SS: 'SSP',
      ES: 'EUR',
      LK: 'LKR',
      SD: 'SDG',
      SR: 'SRD',
      SJ: 'NOK',
      SE: 'SEK',
      CH: 'CHF',
      SY: 'SYP',
      TW: 'TWD',
      TJ: 'TJS',
      TZ: 'TZS',
      TH: 'THB',
      TL: 'USD',
      TG: 'XOF',
      TK: 'NZD',
      TO: 'TOP',
      TT: 'TTD',
      TN: 'TND',
      TR: 'TRY',
      TM: 'TMT',
      TC: 'USD',
      TV: 'AUD',
      UG: 'UGX',
      UA: 'UAH',
      AE: 'AED',
      GB: 'GBP',
      UM: 'USD',
      US: 'USD',
      UY: 'UYI',
      UZ: 'UZS',
      VU: 'VUV',
      VE: 'VEF',
      VN: 'VND',
      VG: 'USD',
      VI: 'USD',
      WF: 'XPF',
      EH: 'MAD',
      YE: 'YER',
      ZM: 'ZMW',
      ZW: 'ZWL',
      AX: 'EUR'
    };
    E.paypal_currency_list = ['AUD', 'BRL', 'CAD', 'CZK', 'DKK', 'EUR', 'HKD', 'HUF', 'ILS', 'JPY', 'MXN', 'TWD', 'NZD', 'NOK', 'PHP', 'PLN', 'GBP', 'SGD', 'SEK', 'CHF', 'THB', 'USD'];
    E.bluesnap_currency_list = ['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'ARS', 'AUD', 'AWG', 'BAM', 'BBD', 'BGN', 'BHD', 'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BWP', 'BYR', 'CAD', 'CHF', 'CLP', 'CNY', 'CRC', 'CZK', 'DKK', 'DOP', 'DZD', 'EGP', 'EUR', 'FJD', 'GBP', 'GEL', 'GIP', 'GTQ', 'HKD', 'HUF', 'IDR', 'ILS', 'INR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KHR', 'KRW', 'KWD', 'KYD', 'KZT', 'LKR', 'MAD', 'MDL', 'MKD', 'MUR', 'MWK', 'MXN', 'MYR', 'NAD', 'NGN', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'QAR', 'RON', 'RSD', 'SAR', 'SCR', 'SDG', 'SEK', 'SGD', 'THB', 'TND', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'USD', 'UYU', 'UZS', 'VND', 'XCD', 'XOF', 'ZAR', 'COP'];
    E.bluesnap_prohibited_countries = ['AF', 'AX', 'BQ', 'CO', 'CU', 'EU', 'IR', 'IQ', 'XK', 'LB', 'LY', 'MM', 'KP', 'BL', 'SS', 'SD', 'SY', 'TL', 'YE'];
    E.avangate_currency_list = ['USD', 'EUR', 'GBP', 'RON', 'AUD', 'CAD', 'CHF', 'CZK', 'DKK', 'HUF', 'JPY', 'NOK', 'PLN', 'SEK', 'TRY', 'RUB', 'CNY', 'BGN', 'BRL', 'HKD', 'KRW', 'MXN', 'NZD', 'SGD', 'ZAR', 'MDL', 'AED', 'EGP', 'INR', 'RSD', 'UAH', 'TWD', 'ILS', 'QAR', 'SAR', 'ARS', 'CLP', 'BOB', 'COP', 'PYG', 'PEN', 'UYU', 'NGN', 'NAD', 'TND', 'DZD', 'KES', 'BYN'];
    E.avangate_prohibited_countries = ['CU', 'IR', 'LY', 'SD', 'SY', 'KP', 'AF', 'DZ', 'AS', 'AG', 'BS', 'BJ', 'BW', 'BN', 'KH', 'CM', 'CI', 'FO', 'GF', 'GA', 'GE', 'GH', 'GL', 'GP', 'GG', 'GN', 'IQ', 'JM', 'LY', 'MV', 'ML', 'MZ', 'MM', 'NA', 'NC', 'NI', 'MP', 'QA', 'RE', 'RW', 'SN', 'SC', 'SZ', 'TJ', 'TZ', 'TL', 'TN', 'TM', 'UG', 'UM', 'VE', 'YE'];
    E.stripe_currency_list = ['USD', 'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BDT', 'BGN', 'BIF', 'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BWP', 'BZD', 'CAD', 'CDF', 'CHF', 'CLP', 'CNY', 'COP', 'CRC', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'ISK', 'JMD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KRW', 'KYD', 'KZT', 'LAK', 'LKR', 'LRD', 'LSL', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MUR', 'MVR', 'MWK', 'MXN', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RWF', 'SAR', 'SBD', 'SCR', 'SEK', 'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'STD', 'SZL', 'THB', 'TJS', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'UYU', 'VND', 'VUV', 'WST', 'XAF', 'XCD', 'XOF', 'XPF', 'YER', 'ZAR', 'ZMW'];

    // according to https://support.bluesnap.com/docs/currencies and experience
    E.currency_decimals = {
      BYR: 0,
      CLP: 0,
      JPY: 0,
      KRW: 0,
      VND: 0,
      XOF: 0,
      HUF: 0,
      TWD: 0,
      ISK: 0,
      ALL: 0,
      ARS: 0,
      COP: 0,
      CRC: 0,
      IDR: 0,
      KHR: 0,
      LBP: 0,
      MWK: 0,
      SDG: 0,
      TZS: 0,
      UZS: 0
    };

    // according to https://docs.adyen.com/development-resources/currency-codes/
    E.adyen_currency_units = {
      AED: 2,
      ALL: 2,
      AMD: 2,
      ANG: 2,
      AOA: 2,
      ARS: 2,
      AUD: 2,
      AWG: 2,
      AZN: 2,
      BAM: 2,
      BBD: 2,
      BDT: 2,
      BGN: 2,
      BHD: 3,
      BMD: 2,
      BND: 2,
      BOB: 2,
      BRL: 2,
      BSD: 2,
      BWP: 2,
      BYN: 2,
      BZD: 2,
      CAD: 2,
      CHF: 2,
      CLP: 2,
      CNH: 2,
      CNY: 2,
      COP: 2,
      CRC: 2,
      CUP: 2,
      CVE: 0,
      CZK: 2,
      DJF: 0,
      DKK: 2,
      DOP: 2,
      DZD: 2,
      EGP: 2,
      ETB: 2,
      EUR: 2,
      FJD: 2,
      FKP: 2,
      GBP: 2,
      GEL: 2,
      GHS: 2,
      GIP: 2,
      GMD: 2,
      GNF: 0,
      GTQ: 2,
      GYD: 2,
      HKD: 2,
      HNL: 2,
      HTG: 2,
      HUF: 2,
      IDR: 0,
      ILS: 2,
      INR: 2,
      IQD: 3,
      ISK: 2,
      JMD: 2,
      JOD: 3,
      JPY: 0,
      KES: 2,
      KGS: 2,
      KHR: 2,
      KMF: 0,
      KRW: 0,
      KWD: 3,
      KYD: 2,
      KZT: 2,
      LAK: 2,
      LBP: 2,
      LKR: 2,
      LYD: 3,
      MAD: 2,
      MDL: 2,
      MKD: 2,
      MMK: 2,
      MNT: 2,
      MOP: 2,
      MRU: 2,
      MUR: 2,
      MVR: 2,
      MWK: 2,
      MXN: 2,
      MYR: 2,
      MZN: 2,
      NAD: 2,
      NGN: 2,
      NIO: 2,
      NOK: 2,
      NPR: 2,
      NZD: 2,
      OMR: 3,
      PAB: 2,
      PEN: 2,
      PGK: 2,
      PHP: 2,
      PKR: 2,
      PLN: 2,
      PYG: 0,
      QAR: 2,
      RON: 2,
      RSD: 2,
      RUB: 2,
      RWF: 0,
      SAR: 2,
      SBD: 2,
      SCR: 2,
      SEK: 2,
      SGD: 2,
      SHP: 2,
      SLE: 2,
      SOS: 2,
      SRD: 2,
      STN: 2,
      SVC: 2,
      SZL: 2,
      THB: 2,
      TND: 3,
      TOP: 2,
      TRY: 2,
      TTD: 2,
      TWD: 2,
      TZS: 2,
      UAH: 2,
      UGX: 0,
      USD: 2,
      UYU: 2,
      UZS: 2,
      VEF: 2,
      VND: 0,
      VUV: 0,
      WST: 2,
      XAF: 0,
      XCD: 2,
      XOF: 0,
      XPF: 0,
      YER: 2,
      ZAR: 2,
      ZMW: 2
    };
    E.adyen_countries = {
      XK: 'QZ'
    };
    E.currency_sign_list = {
      USD: '$',
      EUR: '€',
      GBP: '£',
      ARS: '$',
      AUD: '$',
      BRL: 'R$',
      CAD: 'C$',
      CHF: 'Fr',
      CZK: 'Kč',
      KRW: '₩',
      INR: '₹',
      ILS: '₪',
      MXN: '$',
      NOK: 'kr',
      PHP: '₱',
      PLN: 'zł',
      RUB: '₽',
      SEK: 'kr',
      SGD: 'S$',
      TRY: '₺'
    };
    E.code2label = function (code) {
      code = code.toUpperCase();
      return E.list[code] || code;
    };
    E.code2hiphen_label = function (code) {
      if (!code) return null;
      var special_cases = {
        'US': 'us',
        'UK': 'uk',
        'GB': 'uk',
        'CI': 'cote-divoire',
        'VG': 'virgin-islands-british',
        'VI': 'virgin-islands-us',
        'CC': 'cocos-islands',
        'NL': 'netherlands',
        'AE': 'uae'
      };
      if (special_cases[code]) return special_cases[code];
      code = code.toUpperCase();
      var country = E.list[code];
      if (!country) return code.toLowerCase();
      return country.replace(/ /g, '-').replace(/\s*\(.*?\)\s*/g, '').replace(/--/g, '-').replace(/-$/g, '').toLowerCase();
    };
    E.hiphen_label2code = function (label) {
      if (!label) return null;
      if (label === 'us') return 'US';
      if (label === 'uk') return 'GB';
      if (label === 'cote-divoire') return 'CI';
      if (label === 'virgin-islands-british') return 'VG';
      if (label === 'virgin-islands-us') return 'VI';
      if (label === 'cocos-islands') return 'CC';
      if (label === 'netherlands') return 'NL';
      if (label === 'uae') return 'AE';
      if (label.length === 2 && E.list[label.toUpperCase()]) return label.toUpperCase();
      var reverse_lookup = {};
      var keys = Object.keys(E.list);
      for (var i = 0; i < keys.length; i++) {
        var code = keys[i];
        var country_name = E.list[code];
        var formatted_name = country_name.replace(/ /g, '-').replace(/\s*\(.*?\)\s*/g, '').replace(/--/g, '-').replace(/-$/g, '').toLowerCase();
        reverse_lookup[formatted_name] = code;
      }
      if (reverse_lookup[label]) return reverse_lookup[label];
      if (label.length > 2) {
        var n_label = label.replace(/-/g, ' ').toLowerCase();
        for (var j = 0; j < keys.length; j++) {
          var country_code = keys[j];
          var country_name_lower = E.list[country_code].toLowerCase();
          var words = country_name_lower.split(' ');
          if (words.indexOf(n_label) !== -1) return country_code;
          if (label.length >= 4 && country_name_lower.indexOf(n_label) !== -1) return country_code;
        }
      }
      return null;
    };
    E.code2adj = function (code) {
      code = code.toUpperCase();
      return E.adj_list[code] || code;
    };
    E.code2timezone = function (code) {
      code = code.toUpperCase();
      return E.timezone[code] || code;
    };
    E.label2code = function (label) {
      for (var i in E.list) {
        if (E.list[i] === label) return i;
      }
      return '';
    };
    E.mixed2code = function (mixed) {
      if (!mixed) return;
      if (/^[A-Z]{2}$/.test(mixed)) return mixed;
      if (mixed.length == 2) return mixed.toUpperCase();
      if (mixed == 'USA') return 'US';
      for (var code in E.list) {
        if (E.list[code].toLowerCase() == mixed.toLowerCase()) return code;
      }
      return mixed;
    };
    E.www2code = function (code) {
      return code == 'UK' ? 'GB' : code == 'uk' ? 'gb' : code;
    };
    E.code2www = function (code) {
      return code == 'GB' ? 'UK' : code == 'gb' ? 'uk' : code;
    };
    E.gl2uule = function (gl) {
      gl = E.www2code(gl.toUpperCase());
      return E.google_list[gl] || gl;
    };
    E.code2currency = function (code) {
      return E.currency_list[code.toUpperCase()];
    };
    E.currency2sign = function (currency) {
      currency = currency && currency.toUpperCase();
      return E.currency_sign_list[currency] || '';
    };
    E.code2currency_sign = function (code) {
      return E.currency2sign(E.code2currency(code));
    };
    E.currency2prefix = function (currency) {
      var sign = E.currency2sign(currency);
      return sign ? sign : currency + ' ';
    };
    E.format_sign_before_price = function (sign, price) {
      return sign + price;
    };
    E.format_sign_before_price_with_space = function (sign, price) {
      return sign + ' ' + price;
    };
    E.format_sign_after_price = function (sign, price) {
      return price + sign;
    };
    E.format_sign_after_price_with_space = function (sign, price) {
      return price + ' ' + sign;
    };
    E.sign_format_list = {
      USD: E.format_sign_before_price,
      EUR: E.format_sign_after_price_with_space,
      GBP: E.format_sign_before_price,
      ARS: E.format_sign_before_price,
      AUD: E.format_sign_before_price,
      BRL: E.format_sign_before_price,
      CAD: E.format_sign_before_price,
      CHF: E.format_sign_before_price_with_space,
      CZK: E.format_sign_after_price_with_space,
      KRW: E.format_sign_before_price,
      INR: E.format_sign_before_price,
      ILS: E.format_sign_before_price,
      MXN: E.format_sign_before_price,
      NOK: E.format_sign_after_price_with_space,
      PHP: E.format_sign_before_price,
      PLN: E.format_sign_after_price_with_space,
      RUB: E.format_sign_after_price,
      SEK: E.format_sign_after_price_with_space,
      SGD: E.format_sign_before_price,
      TRY: E.format_sign_after_price
    };
    E.format_price = function (currency, price, disable_rounding) {
      var sign = E.currency2sign(currency);
      var format = E.sign_format_list[currency];
      var fraction_digits = E.get_currency_decimals(currency);
      var options = !disable_rounding ? {
        minimumFractionDigits: fraction_digits,
        maximumFractionDigits: fraction_digits
      } : {};
      if (!currency) return price.toLocaleString(undefined, options);
      if (!sign || !format) return currency + ' ' + price.toLocaleString(undefined, options);
      return format(sign, price.toLocaleString(undefined, options));
    };
    var currency_rlist;
    E.get_currency_rlist = function () {
      if (currency_rlist) return currency_rlist;
      currency_rlist = {};
      for (var co in E.currency_list) {
        var cu = E.currency_list[co];
        if (!currency_rlist[cu]) currency_rlist[cu] = co;else {
          if (!Array.isArray(currency_rlist[cu])) currency_rlist[cu] = [currency_rlist[cu]];
          currency_rlist[cu].push(co);
        }
      }
      return currency_rlist;
    };
    E.get_currency_decimals = function (currency) {
      var decimals = E.currency_decimals[currency && currency.toUpperCase()];
      return decimals === undefined ? 2 : decimals;
    };
    E.country2isocode = function (country) {
      return country_lookup[('' + country).toLowerCase()];
    };
    E.isocode2country = function (iso_code) {
      var name = E.iso_list[iso_code];
      return Array.isArray(name) ? name[0] : name;
    };
    var country_lookup = function () {
      var lookup = {};
      Object.keys(E.iso_list).forEach(function (iso_code) {
        var names = E.iso_list[iso_code];
        (Array.isArray(names) ? names : [names]).forEach(function (n) {
          lookup[n.toLowerCase()] = iso_code;
        });
      });
      return lookup;
    }();
    E.get_continent_adjective_form = function (continent_name) {
      var forms = {
        'europe': 'European',
        'north america': 'North American',
        'latin america': 'Latin American',
        'asia': 'Asian',
        'africa': 'African',
        'oceania': 'Oceanian'
      };
      var continent_mapping = {
        'europe': 'Europe',
        'north america': 'Northern America',
        'latin america': 'LATAM',
        'asia': 'Asia',
        'africa': 'Africa',
        'oceania': 'Oceania'
      };
      var continent_code_mapping = {
        'europe': 'EU',
        'north america': 'NA',
        'latin america': 'SA',
        'asia': 'AS',
        'africa': 'AF',
        'oceania': 'OC'
      };
      var continent_lower_name = continent_name != null ? continent_name.toLowerCase() : undefined;
      return {
        code: continent_code_mapping[continent_lower_name],
        adjective: forms[continent_lower_name] || continent_name,
        key: continent_mapping[continent_lower_name] || continent_name != null ? continent_name.replace(/\b\w/g, function (c) {
          return c.toUpperCase();
        }) : undefined
      };
    };
    E.get_continent_info = function (name) {
      var continent_name = E.continents.find(function (continent) {
        return continent === (name != null ? name.toLowerCase() : undefined);
      });
      if (!continent_name) return null;
      var adjective_form = E.get_continent_adjective_form(continent_name);
      return {
        name: adjective_form.key,
        code: adjective_form.code,
        adjective: adjective_form.adjective
      };
    };
    E.get_country_object = function (code, t) {
      var name = E.code2label(code);
      var name_low = name.toLowerCase();
      var name_locale = t ? t(name == 'Croatia (Hrvatska)' ? 'Croatia' : name).toLowerCase() : '';
      return {
        code: code.toLowerCase(),
        name: name,
        name_low: name_low,
        name_locale: name_locale,
        top: false
      };
    };
    E.find_country_by_name = function (name) {
      var normalized_name = name != null ? name.replace(/-/g, ' ').toUpperCase().trim() : undefined;
      var c = Object.entries(E.list).find(function (list_item) {
        return list_item[0] == normalized_name || list_item[1].toUpperCase() == normalized_name || list_item[1].replace(/-/g, ' ').toUpperCase() == normalized_name;
      });
      if (!c) return null;
      return E.get_country_object(c[0]);
    };
    E.get_location_info = function (location) {
      var continent_info = E.get_continent_info(location);
      if (continent_info) {
        return {
          type: 'continent',
          name: continent_info.name,
          code: continent_info.code
        };
      }
      var region_info = E.us_state_zip_list.find(function (state_item) {
        return state_item.name.toLowerCase() === location;
      });
      if (region_info) {
        return {
          type: 'region',
          code: region_info.code,
          name: region_info.name
        };
      }
      var country_info = E.find_country_by_name(location);
      if (country_info) {
        return {
          type: 'country',
          name: country_info.name,
          code: country_info.code
        };
      }
    };
    E.currency_white_list = function (currency) {
      var c_white = ['USD', 'EUR', 'GBP', 'NIS'];
      if (!c_white.includes(currency)) return 'USD';
      return currency;
    };
    return E;
  });
})();